import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type ConversationInformation = {
  __typename?: 'ConversationInformation';
  conversationId: Scalars['String'];
  encodedAlias: Scalars['String'];
  listingAlias: Scalars['String'];
  referenceId: Scalars['String'];
  referenceIdType: Scalars['String'];
  renterBrand: Scalars['String'];
  renterEmailAddress: Scalars['String'];
  renterName?: Maybe<Scalars['String']>;
};

export type FeatureFlagResponse = {
  __typename?: 'FeatureFlagResponse';
  canAccessBlockedUserModalFromRJSModule?: Maybe<Scalars['Boolean']>;
  enableExternalLinkWarningModal?: Maybe<Scalars['Boolean']>;
  enableInboxIA?: Maybe<Scalars['Boolean']>;
  enableMessageLink?: Maybe<Scalars['Boolean']>;
  enableMessageLinkInSLW?: Maybe<Scalars['Boolean']>;
  enableMessageToolbar?: Maybe<Scalars['Boolean']>;
  enablePersonalInfoWarningModal?: Maybe<Scalars['Boolean']>;
  enableQuickResponse?: Maybe<Scalars['Boolean']>;
  enableRentingBuyingPills?: Maybe<Scalars['Boolean']>;
  enableRescheduleTour?: Maybe<Scalars['Boolean']>;
  enableTMP?: Maybe<Scalars['Boolean']>;
  enableTourScheduling?: Maybe<Scalars['Boolean']>;
  enableUserObjectOptimization?: Maybe<Scalars['Boolean']>;
  enableWebsocketForRachelInbox?: Maybe<Scalars['Boolean']>;
  enableWebsocketIntegration?: Maybe<Scalars['Boolean']>;
};

export type FeatureFlagsAndSettingsResponse = {
  __typename?: 'FeatureFlagsAndSettingsResponse';
  features?: Maybe<FeatureFlagResponse>;
  settings?: Maybe<SettingsResponse>;
};

export enum Folder {
  Archived = 'ARCHIVED',
  Favorite = 'FAVORITE',
  Inbox = 'INBOX',
  ShowAll = 'SHOW_ALL',
  Spam = 'SPAM',
}

export type ListingAnalytics = {
  __typename?: 'ListingAnalytics';
  clickCount: Scalars['Int'];
  feedId: Scalars['String'];
  feedListingId: Scalars['String'];
  impressionCount: Scalars['Int'];
  leadCount: Scalars['Int'];
  listingAliases: Array<Scalars['String']>;
  listingName: Scalars['String'];
  viewCount: Scalars['Int'];
};

export type MarketInsights = {
  __typename?: 'MarketInsights';
  clickAverage: Scalars['Float'];
  daysOnMarketAverage: Scalars['Float'];
  impressionsAverage: Scalars['Float'];
  leadsAverage: Scalars['Float'];
  leadsRate: Scalars['Float'];
  reviewAverage: Scalars['Float'];
  viewsAverage: Scalars['Float'];
  weight: Scalars['Float'];
};

export type Mutation = {
  __typename?: 'Mutation';
  RH_addMessageToConversation: Rh_Message;
  RH_addMessageToConversationV2: Rh_Message;
  /** @deprecated Use the useSatelliteWebConversationHandler_deleteAttachments React Query hook from ts-clients instead. */
  RH_deleteAttachments?: Maybe<Rh_SuccessStatusResponse>;
  RH_RequestToApply: Rh_RequestToApplyResponse;
  RH_updateConversationStatus?: Maybe<Rh_SuccessStatusResponse>;
  RH_updateConversationStatusV2: Rh_SuccessStatusResponse;
  ZRM_addMessageToConversationV2: Zrm_Message;
  ZRM_addSavedReplies: Zrm_GetOrAddSavedRepliesResponse;
  ZRM_addSystemMessageToConversation: Zrm_AddSystemMessageToConversationResponse;
  ZRM_applicationsAccepted?: Maybe<Zrm_SuccessStatusResponse>;
  ZRM_deleteAttachments: Zrm_SuccessStatusResponse;
  ZRM_deleteSavedReplies: Zrm_SuccessStatusResponse;
  ZRM_editSavedReply: Zrm_SuccessStatusResponse;
  ZRM_enableApplications?: Maybe<Zrm_SuccessStatusResponse>;
  ZRM_inviteToApply: Zrm_InviteResponse;
  ZRM_markConversationAsUnread: Zrm_SuccessStatusResponse;
  ZRM_updateConversationAttributes: Zrm_SuccessStatusResponse;
  ZRM_updateConversationStatus: Zrm_SuccessStatusResponse;
  ZRM_updateConversationStatusV2: Zrm_SuccessStatusResponse;
  ZRM_updateNote: Zrm_SuccessStatusResponse;
};

export type MutationRh_AddMessageToConversationArgs = {
  conversationId: Scalars['String'];
  isMessageOwner?: Maybe<Scalars['Boolean']>;
  message: Scalars['String'];
};

export type MutationRh_AddMessageToConversationV2Args = {
  conversationId: Scalars['String'];
  message: Scalars['String'];
  zDocIds: Array<Scalars['String']>;
};

export type MutationRh_DeleteAttachmentsArgs = {
  attachmentsToBeDeleted: Array<Rh_AttachmentToBeDeletedArg>;
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
};

export type MutationRh_RequestToApplyArgs = {
  alias?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  requestToApply?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type MutationRh_UpdateConversationStatusArgs = {
  conversationId: Scalars['String'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isSpam?: Maybe<Scalars['Boolean']>;
  lastReadMs?: Maybe<Scalars['String']>;
};

export type MutationRh_UpdateConversationStatusV2Args = {
  conversationId: Scalars['String'];
  isArchived?: Maybe<Scalars['Boolean']>;
  lastReadMs?: Maybe<Scalars['String']>;
  reportReasonType?: Maybe<ReportConversationReason>;
  userReportComment?: Maybe<Scalars['String']>;
};

export type MutationZrm_AddMessageToConversationV2Args = {
  conversationId: Scalars['String'];
  listingAlias?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  quickResponseSuggestionId?: Maybe<Scalars['String']>;
  zDocIds: Array<Scalars['String']>;
};

export type MutationZrm_AddSavedRepliesArgs = {
  savedReplies: Array<SavedReplyArg>;
};

export type MutationZrm_AddSystemMessageToConversationArgs = {
  conversationId: Scalars['String'];
  messageType: Scalars['String'];
};

export type MutationZrm_ApplicationsAcceptedArgs = {
  applicationsAccepted?: Maybe<Scalars['Boolean']>;
  listingAlias: Scalars['String'];
  requireUserName?: Maybe<Scalars['Boolean']>;
};

export type MutationZrm_DeleteAttachmentsArgs = {
  attachmentsToBeDeleted: Array<Zrm_AttachmentToBeDeletedArg>;
  conversationId: Scalars['String'];
  listingAlias: Scalars['String'];
};

export type MutationZrm_DeleteSavedRepliesArgs = {
  savedReplyIndices: Array<Scalars['Int']>;
};

export type MutationZrm_EditSavedReplyArgs = {
  savedReply: SavedReplyArg;
};

export type MutationZrm_InviteToApplyArgs = {
  listingId: Scalars['String'];
  renterFirstName: Scalars['String'];
  renterLastName: Scalars['String'];
  resendEmail?: Maybe<Scalars['Boolean']>;
  toEmail: Scalars['String'];
};

export type MutationZrm_MarkConversationAsUnreadArgs = {
  conversationId: Scalars['String'];
};

export type MutationZrm_UpdateConversationAttributesArgs = {
  applicationMarkedSent?: Maybe<Scalars['Boolean']>;
  conversationId: Scalars['String'];
  isFavorite?: Maybe<Scalars['Boolean']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  tourScheduledTimestampMs?: Maybe<Scalars['String']>;
};

export type MutationZrm_UpdateConversationStatusArgs = {
  conversationId: Scalars['String'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isSpam?: Maybe<Scalars['Boolean']>;
  lastReadMs?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['String']>;
};

export type MutationZrm_UpdateConversationStatusV2Args = {
  conversationId: Scalars['String'];
  isArchived?: Maybe<Scalars['Boolean']>;
  lastReadMs?: Maybe<Scalars['String']>;
  reportReasonType?: Maybe<ReportConversationReason>;
  userReportComment?: Maybe<Scalars['String']>;
};

export type MutationZrm_UpdateNoteArgs = {
  conversationId: Scalars['String'];
  note: Scalars['String'];
};

export type PortfolioInsights = {
  __typename?: 'PortfolioInsights';
  clickAverage: Scalars['Float'];
  daysOnMarketAverage: Scalars['Float'];
  impressionsAverage: Scalars['Float'];
  leadsAverage: Scalars['Float'];
  leadsRate: Scalars['Float'];
  reviewAverage: Scalars['Float'];
  viewsAverage: Scalars['Float'];
  weight: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  getFeatureFlags?: Maybe<FeatureFlagResponse>;
  getFeatureFlagsAndSettings?: Maybe<FeatureFlagsAndSettingsResponse>;
  RH_getAllForInquiryId: Rh_Conversation;
  RH_getConversationById: Rh_Conversation;
  RH_getDocumentUploadToken?: Maybe<Scalars['String']>;
  RH_getHotpadsUser: User;
  RH_getLatestConversations: Rh_ConversationResponse;
  RH_getSyndicationUrls?: Maybe<Rh_SyndicationUrls>;
  RH_getTruliaUser: User;
  RH_getZdocIdsForMessageTokens: Array<Scalars['String']>;
  RH_getZillowUser: User;
  ZRM_getAbTestVersions: Zrm_AbTestVersionsResponse;
  ZRM_getAggregateConversationCount?: Maybe<Zrm_AggregateConversationCount>;
  ZRM_getAttachmentsByConversationId: Zrm_GetAttachmentsByConversationIdResponse;
  ZRM_getConnectedExperience: Zrm_ConnectedExperience;
  ZRM_getConversationById: Zrm_Conversation;
  ZRM_getConversationCountsForListings?: Maybe<Array<Maybe<Zrm_ListingStats>>>;
  ZRM_getConversationInformationByInquiryId: ConversationInformation;
  ZRM_getConversationSearchResult: Zrm_GetConversationSearchResultResponse;
  ZRM_getDocumentUploadToken?: Maybe<Scalars['String']>;
  ZRM_getExperimentTreatment: Zrm_GetExperimentTreatmentResponse;
  ZRM_getLatestConversationsV2: Zrm_ConversationResponse;
  ZRM_getLeadManagementCounts: Zrm_GetLeadManagementCountsResponse;
  ZRM_getLeadManagementLeads: Zrm_GetLeadManagementLeadsResponse;
  ZRM_getLeadManagementSearchResult: Zrm_GetLeadManagementSearchResultResponse;
  ZRM_getLeadManagementStats: Zrm_GetLeadManagementStatsResponse;
  ZRM_getListingPerformance: Zrm_GetListingPerformanceResponse;
  ZRM_getPropertiesList: Zrm_GetPropertiesListResponse;
  ZRM_getPropertyAddress: Zrm_GetPropertyAddressResponse;
  ZRM_getPropertySearchResult: Zrm_GetPropertySearchResultResponse;
  ZRM_getPropertyWebAnalytics: Zrm_GetPropertyWebAnalyticsResponse;
  ZRM_getSavedReplies: Zrm_GetOrAddSavedRepliesResponse;
  ZRM_getUser: User;
  ZRM_getZdocIdsForMessageTokens: Array<Scalars['String']>;
};

export type QueryGetFeatureFlagsArgs = {
  appName: Scalars['String'];
};

export type QueryGetFeatureFlagsAndSettingsArgs = {
  appName: Scalars['String'];
};

export type QueryRh_GetAllForInquiryIdArgs = {
  includeAttachmentsMetadata?: Maybe<Scalars['Boolean']>;
  inquiryId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  paginationStartIndex?: Maybe<Scalars['String']>;
  startIndex?: Maybe<Scalars['Int']>;
};

export type QueryRh_GetConversationByIdArgs = {
  conversationId: Scalars['String'];
  includeAttachmentsMetadata?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  paginationStartIndex?: Maybe<Scalars['String']>;
  startIndex?: Maybe<Scalars['String']>;
};

export type QueryRh_GetLatestConversationsArgs = {
  archivedOnly?: Maybe<Scalars['Boolean']>;
  daysBack?: Maybe<Scalars['Int']>;
  folder?: Maybe<Folder>;
  limit?: Maybe<Scalars['Int']>;
  notRepliedToOnly?: Maybe<Scalars['Boolean']>;
  paginationStartIndex?: Maybe<Scalars['String']>;
  spamOnly?: Maybe<Scalars['Boolean']>;
  startIndex?: Maybe<Scalars['String']>;
  unreadOnly?: Maybe<Scalars['Boolean']>;
};

export type QueryRh_GetSyndicationUrlsArgs = {
  listingAlias: Scalars['String'];
};

export type QueryRh_GetZdocIdsForMessageTokensArgs = {
  messageTokens: Array<Scalars['String']>;
};

export type QueryZrm_GetAbTestVersionsArgs = {
  enrollInExperiment?: Maybe<Scalars['Boolean']>;
  experimentPercent?: Maybe<Scalars['Int']>;
  tests: Scalars['String'];
};

export type QueryZrm_GetAttachmentsByConversationIdArgs = {
  conversationId: Scalars['String'];
};

export type QueryZrm_GetConnectedExperienceArgs = {
  propertyId: Scalars['String'];
};

export type QueryZrm_GetConversationByIdArgs = {
  clientTimeZone?: Maybe<Scalars['String']>;
  conversationId: Scalars['String'];
  includeAttachmentsMetadata?: Maybe<Scalars['Boolean']>;
  includeInquiryInfo?: Maybe<Scalars['Boolean']>;
  includeRenterProfile?: Maybe<Scalars['Boolean']>;
  includeStatusLabels?: Maybe<Scalars['Boolean']>;
  includeSystemMessages?: Maybe<Scalars['Boolean']>;
  includeUserLeadAttributes?: Maybe<Scalars['Boolean']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['String']>;
  paginationStartIndex?: Maybe<Scalars['String']>;
  startIndex?: Maybe<Scalars['Int']>;
};

export type QueryZrm_GetConversationInformationByInquiryIdArgs = {
  inquiryId: Scalars['String'];
};

export type QueryZrm_GetConversationSearchResultArgs = {
  endTimestampMs: Scalars['String'];
  limit: Scalars['Int'];
  listingAlias?: Maybe<Scalars['String']>;
  offset: Scalars['Int'];
  searchText: Scalars['String'];
  startTimestampMs: Scalars['String'];
};

export type QueryZrm_GetExperimentTreatmentArgs = {
  featureName: Scalars['String'];
  listingAlias?: Maybe<Scalars['String']>;
};

export type QueryZrm_GetLatestConversationsV2Args = {
  clientTimeZone?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['String']>;
  daysBack?: Maybe<Scalars['Int']>;
  endDateYyyyMmDd?: Maybe<Scalars['String']>;
  excludeNote?: Maybe<Scalars['Boolean']>;
  folder?: Maybe<Folder>;
  includeRenterProfile?: Maybe<Scalars['Boolean']>;
  includeStatusLabels?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['String']>;
  paginationStartIndex?: Maybe<Scalars['String']>;
  readRepliedStatus?: Maybe<ReadRepliedStatus>;
  renterProgressStatus?: Maybe<RenterProgressStatus>;
  startDateYyyyMmDd?: Maybe<Scalars['String']>;
  startIndex?: Maybe<Scalars['Int']>;
};

export type QueryZrm_GetLeadManagementCountsArgs = {
  folder?: Maybe<Folder>;
  includePhoneLeads?: Maybe<Scalars['Boolean']>;
  listingAlias: Scalars['String'];
  minCriteriaMatches?: Maybe<Scalars['Int']>;
  readRepliedStatus?: Maybe<ReadRepliedStatus>;
  renterProgressStatus?: Maybe<RenterProgressStatus>;
};

export type QueryZrm_GetLeadManagementLeadsArgs = {
  clientTimeZone: Scalars['String'];
  conversationId?: Maybe<Scalars['String']>;
  folder?: Maybe<Folder>;
  includePhoneLeads?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  listingAlias: Scalars['String'];
  minCriteriaMatches?: Maybe<Scalars['Int']>;
  readRepliedStatus?: Maybe<ReadRepliedStatus>;
  renterProgressStatus?: Maybe<RenterProgressStatus>;
  start?: Maybe<Scalars['Int']>;
};

export type QueryZrm_GetLeadManagementSearchResultArgs = {
  endTimestampMs: Scalars['String'];
  limit: Scalars['Int'];
  listingAlias: Scalars['String'];
  offset: Scalars['Int'];
  searchText: Scalars['String'];
  startTimestampMs: Scalars['String'];
};

export type QueryZrm_GetLeadManagementStatsArgs = {
  listingAlias: Scalars['String'];
};

export type QueryZrm_GetListingPerformanceArgs = {
  endDayYyyyMmDd: Scalars['String'];
  includeFreeStats?: Maybe<Scalars['Boolean']>;
  includeMarketInsights: Scalars['Boolean'];
  includeOlympus?: Maybe<Scalars['Boolean']>;
  listingAlias?: Maybe<Scalars['String']>;
  startDayYyyyMmDd: Scalars['String'];
};

export type QueryZrm_GetPropertiesListArgs = {
  includeActive?: Maybe<Scalars['Boolean']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  includeAtRisk?: Maybe<Scalars['Boolean']>;
  includeFeedClaimAndConvertUpdate?: Maybe<Scalars['Boolean']>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  includeMaintenancePartner?: Maybe<Scalars['Boolean']>;
  includeUnarchived?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  searchText?: Maybe<Scalars['String']>;
  startKeyExclusive?: Maybe<Scalars['String']>;
};

export type QueryZrm_GetPropertyAddressArgs = {
  propertyId: Scalars['String'];
};

export type QueryZrm_GetPropertySearchResultArgs = {
  includeMultifamily?: Maybe<Scalars['Boolean']>;
  includeSingleFamily?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  searchText?: Maybe<Scalars['String']>;
  startKeyExclusive?: Maybe<Scalars['String']>;
};

export type QueryZrm_GetPropertyWebAnalyticsArgs = {
  propertyId: Scalars['String'];
};

export type QueryZrm_GetZdocIdsForMessageTokensArgs = {
  messageTokens: Array<Scalars['String']>;
};

export enum ReadRepliedStatus {
  NotRepliedTo = 'NOT_REPLIED_TO',
  ShowAll = 'SHOW_ALL',
  Unread = 'UNREAD',
}

export enum RenterHubApiTotalMonthlyPriceDisplayType {
  FeesMayApply = 'FEES_MAY_APPLY',
  Legacy = 'LEGACY',
  TotalPrice = 'TOTAL_PRICE',
}

export enum RenterProgressStatus {
  Applicants = 'APPLICANTS',
  Inquiries = 'INQUIRIES',
  ShowAll = 'SHOW_ALL',
  Tenants = 'TENANTS',
  Tours = 'TOURS',
}

export enum ReportConversationReason {
  DiscriminatoryOrAbusive = 'DISCRIMINATORY_OR_ABUSIVE',
  NotReported = 'NOT_REPORTED',
  Other = 'OTHER',
  Spam = 'SPAM',
}

export type Rh_AddressDetails = {
  __typename?: 'RH_AddressDetails';
  stateAbbrev?: Maybe<Scalars['String']>;
};

export type Rh_Application = {
  __typename?: 'RH_Application';
  applicationAlreadySentToRenter?: Maybe<Scalars['Boolean']>;
  applicationId?: Maybe<Scalars['String']>;
  hasRequestedToApply?: Maybe<Scalars['Boolean']>;
  isApplicationEnabledByLandlord?: Maybe<Scalars['Boolean']>;
  isApplicationsAllowed?: Maybe<Scalars['Boolean']>;
};

export type Rh_Attachment = {
  __typename?: 'RH_Attachment';
  attachmentAddedMs?: Maybe<Scalars['String']>;
  attachmentExpirationMs?: Maybe<Scalars['String']>;
  attachmentMetadataStatus?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  downloadUrlExpirationMs?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSizeBytes?: Maybe<Scalars['Int']>;
  fileType?: Maybe<Scalars['String']>;
  isAttachmentDeleted?: Maybe<Scalars['Boolean']>;
  isAttachmentExpired?: Maybe<Scalars['Boolean']>;
  previewUrl?: Maybe<Scalars['String']>;
  previewUrlExpirationMs?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  zDocId?: Maybe<Scalars['String']>;
};

export type Rh_AttachmentToBeDeletedArg = {
  messageId: Scalars['String'];
  zDocId: Scalars['String'];
};

export type Rh_Conversation = {
  __typename?: 'RH_Conversation';
  acceptsReplies?: Maybe<Scalars['Boolean']>;
  acceptsRepliesExplanation?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  addressDetails?: Maybe<Rh_AddressDetails>;
  application?: Maybe<Rh_Application>;
  applicationAlreadySent?: Maybe<Scalars['Boolean']>;
  beds?: Maybe<Scalars['String']>;
  conversation: Array<Rh_Message>;
  conversationId?: Maybe<Scalars['String']>;
  disclaimers?: Maybe<Rh_Disclaimers>;
  encodedAlias?: Maybe<Scalars['String']>;
  feedId: Scalars['String'];
  feedListingId: Scalars['String'];
  hasUnreadMessage: Scalars['Boolean'];
  inquiryId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isApplicationEnabledByLandlord?: Maybe<Scalars['Boolean']>;
  isApplicationsAllowed?: Maybe<Scalars['Boolean']>;
  isConversationBlockedByZillow: Scalars['Boolean'];
  isMultifamily?: Maybe<Scalars['Boolean']>;
  landlordName?: Maybe<Scalars['String']>;
  lastReadTimestampMs?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingName?: Maybe<Scalars['String']>;
  numBathroomsHigh?: Maybe<Scalars['String']>;
  numBathroomsLow?: Maybe<Scalars['String']>;
  pagination?: Maybe<Rh_Pagination>;
  photoUrl?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['String']>;
  pricingDetails?: Maybe<Rh_PricingDetails>;
  pricingDisplay?: Maybe<RenterHubApiTotalMonthlyPriceDisplayType>;
  propertyTypeCode?: Maybe<Scalars['Int']>;
  referenceEmail?: Maybe<Scalars['String']>;
  referenceName?: Maybe<Scalars['String']>;
  referenceRelayEmail?: Maybe<Scalars['String']>;
  status: Rh_ConversationStatus;
};

export type Rh_ConversationResponse = {
  __typename?: 'RH_ConversationResponse';
  conversations: Array<Rh_Conversation>;
  pagination?: Maybe<Rh_Pagination>;
};

export type Rh_ConversationStatus = {
  __typename?: 'RH_ConversationStatus';
  isArchived: Scalars['Boolean'];
  isInvitedToApply: Scalars['Boolean'];
  isScheduled: Scalars['Boolean'];
  isSpam: Scalars['Boolean'];
};

export type Rh_Disclaimer = {
  __typename?: 'RH_Disclaimer';
  disclaimerText: Scalars['String'];
  emailLinks?: Maybe<Array<Maybe<Rh_DisclaimerEmailLink>>>;
  links?: Maybe<Array<Maybe<Rh_DisclaimerLink>>>;
};

export type Rh_DisclaimerEmailLink = {
  __typename?: 'RH_DisclaimerEmailLink';
  emailAddress: Scalars['String'];
  textToDisplay: Scalars['String'];
  textToReplace: Scalars['String'];
};

export type Rh_DisclaimerLink = {
  __typename?: 'RH_DisclaimerLink';
  textToDisplay: Scalars['String'];
  textToReplace: Scalars['String'];
  url: Scalars['String'];
};

export type Rh_Disclaimers = {
  __typename?: 'RH_Disclaimers';
  ai: Rh_Disclaimer;
};

export type Rh_Message = {
  __typename?: 'RH_Message';
  aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
  attachments: Array<Rh_Attachment>;
  conversationId?: Maybe<Scalars['String']>;
  isMessageOwner?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  messageDate?: Maybe<Scalars['String']>;
  messageDateMs: Scalars['String'];
  messageId?: Maybe<Scalars['String']>;
  messageLink?: Maybe<Zrm_Cta_Link>;
  messageType: Scalars['String'];
  senderEmail?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uiTreatmentType?: Maybe<Scalars['String']>;
};

export type Rh_Pagination = {
  __typename?: 'RH_Pagination';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  pageConversationCount?: Maybe<Scalars['Int']>;
  pageStartIndex?: Maybe<Scalars['Int']>;
  queryFullConversationCount?: Maybe<Scalars['Int']>;
};

export type Rh_PricingDetails = {
  __typename?: 'RH_PricingDetails';
  baseRentMax?: Maybe<Scalars['Float']>;
  baseRentMin?: Maybe<Scalars['Float']>;
  isHasBaseRentAndFees: Scalars['Boolean'];
  totalRequiredMonthlyFeeMax?: Maybe<Scalars['Float']>;
  totalRequiredMonthlyFeeMin?: Maybe<Scalars['Float']>;
};

export type Rh_RequestToApplyResponse = {
  __typename?: 'RH_RequestToApplyResponse';
  status?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Rh_SuccessStatusResponse = {
  __typename?: 'RH_SuccessStatusResponse';
  success: Scalars['Boolean'];
};

export type Rh_SyndicationUrls = {
  __typename?: 'RH_SyndicationUrls';
  hotpadsUrl?: Maybe<Scalars['String']>;
  truliaUrl?: Maybe<Scalars['String']>;
  zillowUrl?: Maybe<Scalars['String']>;
};

export enum SatelliteAiAutoResponseType {
  EliseAi = 'ELISE_AI',
}

export type SavedReply = {
  __typename?: 'SavedReply';
  dateUpdatedMs?: Maybe<Scalars['String']>;
  reply: Scalars['String'];
  replyIndex: Scalars['Int'];
  title: Scalars['String'];
};

export type SavedReplyArg = {
  reply: Scalars['String'];
  replyIndex: Scalars['Int'];
  title: Scalars['String'];
};

export type SettingsResponse = {
  __typename?: 'SettingsResponse';
  abTreatmentForTMP?: Maybe<Scalars['String']>;
  aiConversationPollIntervalInSeconds?: Maybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  applicationsEnabled: Scalars['Boolean'];
  canUpdateListing: Scalars['Boolean'];
  csrfToken?: Maybe<Scalars['String']>;
  customers: Array<Zrm_CustomerSummary>;
  email?: Maybe<Scalars['String']>;
  encodedZuid?: Maybe<Scalars['String']>;
  features: Zrm_Features;
  firstName?: Maybe<Scalars['String']>;
  hasAcceptedZillowRentalUserTerms?: Maybe<Scalars['Boolean']>;
  hasPaidForListing?: Maybe<Scalars['Boolean']>;
  hasSeenNewPaymentsPage?: Maybe<Scalars['Boolean']>;
  hasSeenPaymentsAggregatedViewModal?: Maybe<Scalars['Boolean']>;
  hasSeenRentGuarantee?: Maybe<Scalars['Boolean']>;
  hasStrongAuthentication?: Maybe<Scalars['Boolean']>;
  impersonatorEmail?: Maybe<Scalars['String']>;
  impersonatorUserToken?: Maybe<Scalars['String']>;
  isAcceptingApplications?: Maybe<Scalars['Boolean']>;
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  isEnterpriseCustomer?: Maybe<Scalars['Boolean']>;
  isHousingConnector?: Maybe<Scalars['Boolean']>;
  isIdVerified?: Maybe<Scalars['Boolean']>;
  isImpersonationAllowed?: Maybe<Scalars['Boolean']>;
  isLeasingBeta: Scalars['Boolean'];
  isMocked?: Maybe<Scalars['Boolean']>;
  isMultifamilyCustomer: Scalars['Boolean'];
  isPasswordlessAccount?: Maybe<Scalars['Boolean']>;
  isPostingPathAdmin?: Maybe<Scalars['Boolean']>;
  isPremiumCustomer?: Maybe<Scalars['Boolean']>;
  isPropertyManager?: Maybe<Scalars['Boolean']>;
  isPropertyManagerCompanyAdmin?: Maybe<Scalars['Boolean']>;
  isRocketshipCustomer?: Maybe<Scalars['Boolean']>;
  /** @deprecated Field no longer supported */
  isRocketshipCustomerOnly?: Maybe<Scalars['Boolean']>;
  isSelfServeCustomer?: Maybe<Scalars['Boolean']>;
  isSingleFamilyEnterpriseCustomer?: Maybe<Scalars['Boolean']>;
  isTwoFactorAuthEnabled?: Maybe<Scalars['Boolean']>;
  isTwoFactorAuthenticated?: Maybe<Scalars['Boolean']>;
  isUserBlocked?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  loggedIn: Scalars['Boolean'];
  paymentsAcceptedCount?: Maybe<Scalars['Int']>;
  paymentsAccessAllowed: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  phoneNumber?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  profiles?: Maybe<Zrm_Profiles>;
  restrictions?: Maybe<Zrm_Restrictions>;
  /** @deprecated Field no longer supported */
  roles?: Maybe<Array<Scalars['String']>>;
  sessionSecondsRemaining?: Maybe<Scalars['Int']>;
  setCookies?: Maybe<Array<Scalars['String']>>;
  summary?: Maybe<Zrm_Summary>;
  userManagementCompanyId?: Maybe<Scalars['String']>;
  userToken?: Maybe<Scalars['String']>;
};

export type Zrm_AbTestVersionsResponse = {
  __typename?: 'ZRM_AbTestVersionsResponse';
  experimentDtos: Array<Zrm_Experiment>;
};

export type Zrm_AddSystemMessageToConversationResponse = {
  __typename?: 'ZRM_addSystemMessageToConversationResponse';
  brandName?: Maybe<Scalars['String']>;
  conversationId: Scalars['String'];
  dateSentMs: Scalars['String'];
  listingAlias: Scalars['String'];
  message: Scalars['String'];
  messageId: Scalars['String'];
  messageType?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  referenceIdType?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
};

export type Zrm_AggregateConversationCount = {
  __typename?: 'ZRM_AggregateConversationCount';
  notRepliedToCount?: Maybe<Scalars['Int']>;
  totalConversationsCount?: Maybe<Scalars['Int']>;
  unreadCount?: Maybe<Scalars['Int']>;
};

export type Zrm_Attachment = {
  __typename?: 'ZRM_Attachment';
  attachmentAddedMs?: Maybe<Scalars['String']>;
  attachmentExpirationMs?: Maybe<Scalars['String']>;
  attachmentMetadataStatus?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  downloadUrlExpirationMs?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSizeBytes?: Maybe<Scalars['Int']>;
  fileType?: Maybe<Scalars['String']>;
  isAttachmentDeleted?: Maybe<Scalars['Boolean']>;
  isAttachmentExpired?: Maybe<Scalars['Boolean']>;
  previewUrl?: Maybe<Scalars['String']>;
  previewUrlExpirationMs?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  zDocId?: Maybe<Scalars['String']>;
};

export type Zrm_AttachmentToBeDeletedArg = {
  messageId: Scalars['String'];
  zDocId: Scalars['String'];
};

export type Zrm_ConnectedExperience = {
  __typename?: 'ZRM_connectedExperience';
  isConnectedExperience?: Maybe<Scalars['Boolean']>;
};

export type Zrm_Conversation = {
  __typename?: 'ZRM_Conversation';
  acceptsReplies?: Maybe<Scalars['Boolean']>;
  activeParticipantsInConversation: Array<Zrm_ConversationParticipant>;
  address?: Maybe<Scalars['String']>;
  applicationAlreadySent?: Maybe<Scalars['Boolean']>;
  applicationCompleted?: Maybe<Scalars['Boolean']>;
  attributes?: Maybe<Zrm_ConversationAttributes>;
  conversation: Array<Zrm_Message>;
  conversationId: Scalars['String'];
  feedId: Scalars['String'];
  feedListingId: Scalars['String'];
  hasQuickResponses?: Maybe<Scalars['Boolean']>;
  hasUnreadMessage: Scalars['Boolean'];
  inquiry?: Maybe<Zrm_Inquiry>;
  inquiryId: Scalars['String'];
  isActive: Scalars['Boolean'];
  isApplicationsAccepted: Scalars['Boolean'];
  isApplicationsAllowed: Scalars['Boolean'];
  isConversationBlockedByZillow: Scalars['Boolean'];
  isMultifamily: Scalars['Boolean'];
  lastReadTimestampMs?: Maybe<Scalars['String']>;
  listingAlias: Scalars['String'];
  listingId: Scalars['String'];
  note: Zrm_Note;
  notRepliedTo: Scalars['Boolean'];
  pagination?: Maybe<Zrm_Pagination>;
  propertyTypeCode?: Maybe<Scalars['Int']>;
  quickResponses?: Maybe<Zrm_QuickResponses>;
  referenceEmail?: Maybe<Scalars['String']>;
  referenceName?: Maybe<Scalars['String']>;
  referenceRelayEmail?: Maybe<Scalars['String']>;
  rentalProtection?: Maybe<Zrm_RentalProtection>;
  renterProfile?: Maybe<Zrm_RenterProfile>;
  status: Zrm_ConversationStatus;
  statusLabel?: Maybe<Zrm_StatusLabel>;
  touring: Zrm_Touring;
};

export type Zrm_ConversationAttributes = {
  __typename?: 'ZRM_ConversationAttributes';
  applicationMarkedSent?: Maybe<Scalars['Boolean']>;
  attributeUpdateDateMs?: Maybe<Scalars['String']>;
  tourScheduledTimestampMs?: Maybe<Scalars['String']>;
};

export type Zrm_ConversationCountsResponse = {
  __typename?: 'ZRM_ConversationCountsResponse';
  conversationCount?: Maybe<Scalars['Int']>;
  lastMessageDateMs?: Maybe<Scalars['String']>;
  listingConversationCount?: Maybe<Scalars['Int']>;
  listingCounts: Array<Zrm_ListingCount>;
  unreadConversationCount?: Maybe<Scalars['Int']>;
  unreadMessageCount?: Maybe<Scalars['Int']>;
};

export type Zrm_ConversationParticipant = {
  __typename?: 'ZRM_ConversationParticipant';
  name: Scalars['String'];
  relayAddress?: Maybe<Scalars['String']>;
};

export type Zrm_ConversationResponse = {
  __typename?: 'ZRM_ConversationResponse';
  conversations: Array<Zrm_Conversation>;
  listingId?: Maybe<Scalars['String']>;
  pagination?: Maybe<Zrm_Pagination>;
};

export type Zrm_ConversationSearchResult = {
  __typename?: 'ZRM_ConversationSearchResult';
  conversationId?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  renterName?: Maybe<Scalars['String']>;
  renterPhoneNumber?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
};

export type Zrm_ConversationStatus = {
  __typename?: 'ZRM_ConversationStatus';
  isArchived: Scalars['Boolean'];
  isFavorite: Scalars['Boolean'];
  isInvitedToApply: Scalars['Boolean'];
  isScheduled: Scalars['Boolean'];
  isSpam: Scalars['Boolean'];
};

export type Zrm_Cta_Link = {
  __typename?: 'ZRM_CTA_Link';
  linkData?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type Zrm_CustomerSummary = {
  __typename?: 'ZRM_CustomerSummary';
  active?: Maybe<Scalars['Boolean']>;
  customerType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryUserAccount?: Maybe<Scalars['String']>;
  userManagementCompanyId?: Maybe<Scalars['String']>;
  zrnNumber?: Maybe<Scalars['String']>;
};

export type Zrm_Experiment = {
  __typename?: 'ZRM_Experiment';
  experimentName: Scalars['String'];
  experimentPercent?: Maybe<Scalars['Int']>;
  jira: Scalars['String'];
  shouldTrack: Scalars['Boolean'];
  version: Scalars['String'];
};

export type Zrm_Features = {
  __typename?: 'ZRM_Features';
  canAccessAnalytics?: Maybe<Scalars['Boolean']>;
  canAccessBilling?: Maybe<Scalars['Boolean']>;
  canAccessBusinessVerificationLite?: Maybe<Scalars['Boolean']>;
  canAccessConnectedExperience?: Maybe<Scalars['Boolean']>;
  /** @deprecated Field no longer supported */
  canAccessContacts?: Maybe<Scalars['Boolean']>;
  canAccessDeactivationWorkflow?: Maybe<Scalars['Boolean']>;
  canAccessFeatureLaunchNotifications?: Maybe<Scalars['Boolean']>;
  canAccessFeedClaimAndConvert?: Maybe<Scalars['Boolean']>;
  canAccessInvoicePayments?: Maybe<Scalars['Boolean']>;
  canAccessListingCriteria?: Maybe<Scalars['Boolean']>;
  canAccessMainAccountSettings?: Maybe<Scalars['Boolean']>;
  canAccessMainAnalytics?: Maybe<Scalars['Boolean']>;
  canAccessMainBilling?: Maybe<Scalars['Boolean']>;
  canAccessMainContacts?: Maybe<Scalars['Boolean']>;
  canAccessMainContactSupport?: Maybe<Scalars['Boolean']>;
  canAccessMainHelp?: Maybe<Scalars['Boolean']>;
  canAccessMainMaintenanceTracker?: Maybe<Scalars['Boolean']>;
  canAccessMainMessages?: Maybe<Scalars['Boolean']>;
  canAccessMainMyProperties?: Maybe<Scalars['Boolean']>;
  canAccessMainNotificationCenter?: Maybe<Scalars['Boolean']>;
  canAccessMainPayments?: Maybe<Scalars['Boolean']>;
  canAccessMainResources?: Maybe<Scalars['Boolean']>;
  canAccessMainSecuritySettings?: Maybe<Scalars['Boolean']>;
  canAccessMaintenanceTracker?: Maybe<Scalars['Boolean']>;
  canAccessMessages?: Maybe<Scalars['Boolean']>;
  canAccessMobileHub?: Maybe<Scalars['Boolean']>;
  canAccessModularListing?: Maybe<Scalars['Boolean']>;
  canAccessMultiFamilyResources?: Maybe<Scalars['Boolean']>;
  canAccessNewPhotoUpload?: Maybe<Scalars['Boolean']>;
  canAccessPostActivationFeedListingEdits?: Maybe<Scalars['Boolean']>;
  canAccessPostActivationListingEdits?: Maybe<Scalars['Boolean']>;
  canAccessUserManagement?: Maybe<Scalars['Boolean']>;
  canAccessUserManagementApplicationPermission?: Maybe<Scalars['Boolean']>;
  canAddListing?: Maybe<Scalars['Boolean']>;
  canDeleteListing?: Maybe<Scalars['Boolean']>;
  canEditMultifamilyFeedListingContactInformation?: Maybe<Scalars['Boolean']>;
  canRespondToReview?: Maybe<Scalars['Boolean']>;
  canSwitchListingSource?: Maybe<Scalars['Boolean']>;
  canUpdateListing?: Maybe<Scalars['Boolean']>;
  canViewClaimFeedListing?: Maybe<Scalars['Boolean']>;
  canViewContactEmailDeliverability?: Maybe<Scalars['Boolean']>;
  canViewOnboardingFlow?: Maybe<Scalars['Boolean']>;
  canViewSingleFamilyFeedListingDetails?: Maybe<Scalars['Boolean']>;
};

export type Zrm_FunnelReportAnalytics = {
  __typename?: 'ZRM_FunnelReportAnalytics';
  averageStarLevel?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  clickCount?: Maybe<Scalars['Int']>;
  daysOnMarketCount?: Maybe<Scalars['Int']>;
  emailLeadCount?: Maybe<Scalars['Int']>;
  feedId?: Maybe<Scalars['String']>;
  feedListingId?: Maybe<Scalars['String']>;
  impressionCount?: Maybe<Scalars['Int']>;
  isSingleFamily?: Maybe<Scalars['Boolean']>;
  leadCount?: Maybe<Scalars['Int']>;
  leaseCount?: Maybe<Scalars['Int']>;
  listingName?: Maybe<Scalars['String']>;
  percentageResponse?: Maybe<Scalars['Float']>;
  phoneLeadCount?: Maybe<Scalars['Int']>;
  productType?: Maybe<Array<Maybe<Scalars['String']>>>;
  publishedStatus?: Maybe<Scalars['String']>;
  reviewCount?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  viewCount?: Maybe<Scalars['Int']>;
  zip?: Maybe<Scalars['String']>;
};

export type Zrm_FunnelReportInsights = {
  __typename?: 'ZRM_FunnelReportInsights';
  market?: Maybe<Zrm_FunnelReportMarketInsights>;
  portfolio?: Maybe<Zrm_FunnelReportPortfolioInsights>;
  portfolioLeadsTotal?: Maybe<Scalars['Int']>;
  portfolioTotalListings?: Maybe<Scalars['Int']>;
};

export type Zrm_FunnelReportMarketInsights = {
  __typename?: 'ZRM_FunnelReportMarketInsights';
  daysOnMarketAverage?: Maybe<Scalars['Float']>;
  impressionsAverage?: Maybe<Scalars['Float']>;
  leadsAverage?: Maybe<Scalars['Float']>;
  leadsRate?: Maybe<Scalars['Float']>;
  reviewAverage?: Maybe<Scalars['Float']>;
  viewsAverage?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type Zrm_FunnelReportPortfolioInsights = {
  __typename?: 'ZRM_FunnelReportPortfolioInsights';
  daysOnMarketAverage?: Maybe<Scalars['Float']>;
  impressionsAverage?: Maybe<Scalars['Float']>;
  leadsAverage?: Maybe<Scalars['Float']>;
  leadsRate?: Maybe<Scalars['Float']>;
  reviewAverage?: Maybe<Scalars['Float']>;
  viewsAverage?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type Zrm_FunnelReportProductTypeInsights = {
  __typename?: 'ZRM_FunnelReportProductTypeInsights';
  FLAT_FEE?: Maybe<Zrm_FunnelReportInsights>;
  PAY_PER_LEAD?: Maybe<Zrm_FunnelReportInsights>;
  PREMIUM_PLUS_PACKAGE?: Maybe<Zrm_FunnelReportInsights>;
};

export type Zrm_GetAttachmentsByConversationIdResponse = {
  __typename?: 'ZRM_getAttachmentsByConversationIdResponse';
  attachments: Array<Zrm_Attachment>;
};

export type Zrm_GetConversationSearchResultResponse = {
  __typename?: 'ZRM_getConversationSearchResultResponse';
  hasMore: Scalars['Boolean'];
  searchResult: Array<Maybe<Zrm_ConversationSearchResult>>;
};

export type Zrm_GetExperimentTreatmentResponse = {
  __typename?: 'ZRM_getExperimentTreatmentResponse';
  featureName?: Maybe<Scalars['String']>;
  treatment?: Maybe<Scalars['String']>;
};

export type Zrm_GetLeadManagementCountsResponse = {
  __typename?: 'ZRM_getLeadManagementCountsResponse';
  totalLeadCount: Scalars['Int'];
};

export type Zrm_GetLeadManagementLeadsResponse = {
  __typename?: 'ZRM_getLeadManagementLeadsResponse';
  earliestDateSearchedMs: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
  leads: Array<Zrm_LeadManagementLead>;
  listingDetails: Zrm_LeadManagementListingDetail;
  pageLeadCount: Scalars['Int'];
  screeningCriteriaDetails: Zrm_LeadManagementScreeningCriteriaDetail;
  tooMuchDataRequested: Scalars['Boolean'];
  totalLeadCount: Scalars['Int'];
};

export type Zrm_GetLeadManagementSearchResultResponse = {
  __typename?: 'ZRM_getLeadManagementSearchResultResponse';
  hasMore: Scalars['Boolean'];
  responseEntries: Array<Maybe<Zrm_GetLeadManagementSearchResultResponseEntry>>;
};

export type Zrm_GetLeadManagementSearchResultResponseEntry = {
  __typename?: 'ZRM_getLeadManagementSearchResultResponseEntry';
  conversationId: Scalars['String'];
  screeningCriteria: Zrm_LeadManagementSearchScreeningCriteria;
  searchEntry: Zrm_LeadManagementSearchEntry;
};

export type Zrm_GetLeadManagementStatsResponse = {
  __typename?: 'ZRM_getLeadManagementStatsResponse';
  hasCriteriaSet: Scalars['Boolean'];
  leadsQualifiedForCriteriaTotal: Scalars['Int'];
  listingAddress: Scalars['String'];
  stats: Array<Maybe<Zrm_LeadManagementStats>>;
};

export type Zrm_GetListingPerformanceResponse = {
  __typename?: 'ZRM_getListingPerformanceResponse';
  analytics: Array<Maybe<ListingAnalytics>>;
  insights: Zrm_Insights;
};

export type Zrm_GetOrAddSavedRepliesResponse = {
  __typename?: 'ZRM_getOrAddSavedRepliesResponse';
  customReplies: Array<Maybe<SavedReply>>;
  defaultSavedReplies: Array<SavedReply>;
  success: Scalars['Boolean'];
};

export type Zrm_GetPropertiesListPagination = {
  __typename?: 'ZRM_GetPropertiesListPagination';
  endKey?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  startKey?: Maybe<Scalars['String']>;
};

export type Zrm_GetPropertiesListResponse = {
  __typename?: 'ZRM_GetPropertiesListResponse';
  listingCount: Zrm_PropertyListingCount;
  listings: Array<Zrm_PropertyListing>;
  pager: Zrm_GetPropertiesListPagination;
};

export type Zrm_GetPropertyAddressResponse = {
  __typename?: 'ZRM_GetPropertyAddressResponse';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Zrm_GetPropertySearchResultResponse = {
  __typename?: 'ZRM_GetPropertySearchResultResponse';
  listings: Array<Zrm_PropertyListing>;
  pager: Zrm_GetPropertiesListPagination;
};

export type Zrm_GetPropertyWebAnalyticsResponse = {
  __typename?: 'ZRM_GetPropertyWebAnalyticsResponse';
  eventProductType?: Maybe<Scalars['String']>;
  isApplicationsAccepted?: Maybe<Scalars['Boolean']>;
  listingAlias?: Maybe<Scalars['String']>;
  rentGuarantee?: Maybe<Zrm_RentGuarantee>;
};

export type Zrm_Inquiry = {
  __typename?: 'ZRM_Inquiry';
  attributes?: Maybe<Zrm_RenterResume>;
  contactEmail?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  feed?: Maybe<Scalars['String']>;
  feedListingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inquirerType?: Maybe<Scalars['String']>;
  isAttributesHidden?: Maybe<Scalars['Boolean']>;
  isPhoneLead?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
};

export type Zrm_Insights = {
  __typename?: 'ZRM_Insights';
  market: MarketInsights;
  portfolio: PortfolioInsights;
  portfolioClickCount: Scalars['Int'];
  portfolioDaysOnMarketCount: Scalars['Int'];
  portfolioImpressionCount: Scalars['Int'];
  portfolioLeadsTotal: Scalars['Int'];
  portfolioTotalListings: Scalars['Int'];
  portfolioViewCount: Scalars['Int'];
};

export type Zrm_InviteResponse = {
  __typename?: 'ZRM_InviteResponse';
  response: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Zrm_LeadManagementApplicationInfo = {
  __typename?: 'ZRM_LeadManagementApplicationInfo';
  isApplicationCompleted: Scalars['Boolean'];
  isApplicationsAccepted: Scalars['Boolean'];
  isApplicationSent: Scalars['Boolean'];
  numCoApplicants: Scalars['Int'];
};

export type Zrm_LeadManagementConversationAttributes = {
  __typename?: 'ZRM_LeadManagementConversationAttributes';
  applicationMarkedSent: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  tourScheduledTimestampMs?: Maybe<Scalars['String']>;
};

export type Zrm_LeadManagementConversationStatus = {
  __typename?: 'ZRM_LeadManagementConversationStatus';
  applicationMarkedSent: Scalars['Boolean'];
  isArchived: Scalars['Boolean'];
  isConversationBlockedByZillow: Scalars['Boolean'];
  isFavorite: Scalars['Boolean'];
  isScheduled: Scalars['Boolean'];
  isSpam: Scalars['Boolean'];
};

export type Zrm_LeadManagementCriterion = {
  __typename?: 'ZRM_LeadManagementCriterion';
  hasMatchingCriterion: Scalars['Boolean'];
  isCriterionSet: Scalars['Boolean'];
  isNegotiable: Scalars['Boolean'];
  renterDataToolTipText?: Maybe<Scalars['String']>;
  rentersCriterionSubmittedDisplay?: Maybe<Scalars['String']>;
  screeningCriteriaType: Scalars['String'];
  screeningCriterionDisplay?: Maybe<Scalars['String']>;
  screeningCriterionNameDisplay: Scalars['String'];
};

export type Zrm_LeadManagementLatestContact = {
  __typename?: 'ZRM_LeadManagementLatestContact';
  aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
  hasAttachments: Scalars['Boolean'];
  isMessageOwner: Scalars['Boolean'];
  isNew: Scalars['Boolean'];
  isPhoneLead: Scalars['Boolean'];
  isRead: Scalars['Boolean'];
  messageDateMs: Scalars['String'];
  messageText?: Maybe<Scalars['String']>;
  messageType: Scalars['String'];
  notRepliedTo: Scalars['Boolean'];
  senderName?: Maybe<Scalars['String']>;
};

export type Zrm_LeadManagementLead = {
  __typename?: 'ZRM_LeadManagementLead';
  applicationInfo: Zrm_LeadManagementApplicationInfo;
  attributes?: Maybe<Zrm_LeadManagementConversationAttributes>;
  conversationId: Scalars['String'];
  latestContact: Zrm_LeadManagementLatestContact;
  nextStep: Zrm_LeadManagementNextStep;
  renterInfo: Zrm_LeadManagementRenterInfo;
  renterProfile?: Maybe<Zrm_RenterProfile>;
  renterProgressBar: Zrm_LeadManagementRenterProgressBar;
  screeningCriteria: Zrm_LeadManagementScreeningCriteria;
  status: Zrm_LeadManagementConversationStatus;
  statusLabel?: Maybe<Zrm_StatusLabel>;
  touring: Zrm_Touring;
};

export type Zrm_LeadManagementListingDetail = {
  __typename?: 'ZRM_LeadManagementListingDetail';
  listingAddress: Scalars['String'];
  listingAlias: Scalars['String'];
};

export type Zrm_LeadManagementNextStep = {
  __typename?: 'ZRM_LeadManagementNextStep';
  link: Zrm_LeadManagementNextStepLink;
  nextStepType: Scalars['String'];
};

export type Zrm_LeadManagementNextStepLink = {
  __typename?: 'ZRM_LeadManagementNextStepLink';
  linkData?: Maybe<Scalars['String']>;
  linkId: Scalars['String'];
  text: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type Zrm_LeadManagementProgressBarStatus = {
  __typename?: 'ZRM_LeadManagementProgressBarStatus';
  hasStatusLabel: Scalars['Boolean'];
  statusType: Scalars['String'];
};

export type Zrm_LeadManagementRenterInfo = {
  __typename?: 'ZRM_LeadManagementRenterInfo';
  firstContactDateMs: Scalars['String'];
  renterName?: Maybe<Scalars['String']>;
  renterPhoneNumber?: Maybe<Scalars['String']>;
  renterRelayEmailAddress?: Maybe<Scalars['String']>;
};

export type Zrm_LeadManagementRenterProgressBar = {
  __typename?: 'ZRM_LeadManagementRenterProgressBar';
  application: Zrm_LeadManagementProgressBarStatus;
  inquiry: Zrm_LeadManagementProgressBarStatus;
  lease: Zrm_LeadManagementProgressBarStatus;
  tour: Zrm_LeadManagementProgressBarStatus;
};

export type Zrm_LeadManagementScreeningCriteria = {
  __typename?: 'ZRM_LeadManagementScreeningCriteria';
  criteria: Array<Zrm_LeadManagementCriterion>;
  criteriaMatchedDisplay: Scalars['String'];
  hasScreeningCriteria: Scalars['Boolean'];
  hasSubmittedProfile: Scalars['Boolean'];
  numCriteriaSelectedByLandlord?: Maybe<Scalars['Int']>;
  numRequiredCriteriaSelectedByLandlord: Scalars['Int'];
  numRequiredOrNegotiableCriteriaSelectedByLandlordThatMatch?: Maybe<Scalars['Int']>;
  shouldShowRequestRenterProfileCta: Scalars['Boolean'];
};

export type Zrm_LeadManagementScreeningCriteriaDetail = {
  __typename?: 'ZRM_LeadManagementScreeningCriteriaDetail';
  hasCriteriaSet: Scalars['Boolean'];
  isScreeningCriteriaIncomplete: Scalars['Boolean'];
};

export type Zrm_LeadManagementSearchEntry = {
  __typename?: 'ZRM_LeadManagementSearchEntry';
  conversationId?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  renterName?: Maybe<Scalars['String']>;
  renterPhoneNumber?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
};

export type Zrm_LeadManagementSearchScreeningCriteria = {
  __typename?: 'ZRM_LeadManagementSearchScreeningCriteria';
  criteriaMatchedDisplay?: Maybe<Scalars['String']>;
  numCriteriaSelectedByLandlord?: Maybe<Scalars['Int']>;
  numCriteriaSelectedByLandlordThatPossiblyMatch?: Maybe<Scalars['Int']>;
  numRequiredCriteriaSelectedByLandlord?: Maybe<Scalars['Int']>;
  numRequiredCriteriaSelectedByLandlordThatMatch?: Maybe<Scalars['Int']>;
  numRequiredOrNegotiableCriteriaSelectedByLandlordThatMatch?: Maybe<Scalars['Int']>;
  numSelectableCriteria?: Maybe<Scalars['Int']>;
};

export type Zrm_LeadManagementStats = {
  __typename?: 'ZRM_LeadManagementStats';
  criterionMatchedCount: Scalars['Int'];
  isCriterionSet: Scalars['Boolean'];
  isNegotiable: Scalars['Boolean'];
  percentageMatched: Scalars['String'];
  screeningCriteriaType: Scalars['String'];
  screeningCriterionDisplay?: Maybe<Scalars['String']>;
  screeningCriterionNameDisplay: Scalars['String'];
};

export type Zrm_Listing = {
  __typename?: 'ZRM_Listing';
  city?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Zrm_ListingCount = {
  __typename?: 'ZRM_ListingCount';
  address: Scalars['String'];
  conversationCount?: Maybe<Scalars['Int']>;
  feedId: Scalars['String'];
  feedListingId: Scalars['String'];
  unreadConversationCount?: Maybe<Scalars['Int']>;
  unreadMessageCount?: Maybe<Scalars['Int']>;
};

export type Zrm_ListingStats = {
  __typename?: 'ZRM_ListingStats';
  aliasEncoded?: Maybe<Scalars['String']>;
  listingAlias?: Maybe<Scalars['String']>;
  listingId?: Maybe<Scalars['String']>;
  notRepliedToCount?: Maybe<Scalars['Int']>;
  totalConversationsCount?: Maybe<Scalars['Int']>;
  unreadCount?: Maybe<Scalars['Int']>;
};

export type Zrm_Message = {
  __typename?: 'ZRM_Message';
  aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
  attachments: Array<Zrm_Attachment>;
  conversationId?: Maybe<Scalars['String']>;
  ctaLink?: Maybe<Scalars['String']>;
  ctaText?: Maybe<Scalars['String']>;
  isMessageOwner?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  messageDate?: Maybe<Scalars['String']>;
  messageDateMs: Scalars['String'];
  messageId?: Maybe<Scalars['String']>;
  messageLink?: Maybe<Zrm_Cta_Link>;
  messagePreview?: Maybe<Scalars['String']>;
  messageType: Scalars['String'];
  senderEmail?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uiTreatmentType?: Maybe<Scalars['String']>;
};

export type Zrm_Note = {
  __typename?: 'ZRM_Note';
  conversationId?: Maybe<Scalars['String']>;
  lastUpdatedMs?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

export type Zrm_Pagination = {
  __typename?: 'ZRM_Pagination';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  pageConversationCount?: Maybe<Scalars['Int']>;
  pageStartIndex?: Maybe<Scalars['Int']>;
  queryFullConversationCount?: Maybe<Scalars['Int']>;
  queryFullMessageCount?: Maybe<Scalars['Int']>;
};

export type Zrm_PartialMessages = {
  __typename?: 'ZRM_PartialMessages';
  className?: Maybe<Scalars['String']>;
  isBold?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Zrm_Profiles = {
  __typename?: 'ZRM_Profiles';
  isLandlord?: Maybe<Scalars['Boolean']>;
  isPropertyManager?: Maybe<Scalars['Boolean']>;
};

export type Zrm_PropertyListing = {
  __typename?: 'ZRM_PropertyListing';
  address?: Maybe<Zrm_PropertyListingAddress>;
  isMultifamily?: Maybe<Scalars['Boolean']>;
  listingAlias?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Zrm_PropertyListingAddress = {
  __typename?: 'ZRM_PropertyListingAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type Zrm_PropertyListingCount = {
  __typename?: 'ZRM_PropertyListingCount';
  active?: Maybe<Scalars['Int']>;
  archived?: Maybe<Scalars['Int']>;
  atRisk?: Maybe<Scalars['Int']>;
  inactive?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type Zrm_QuickResponses = {
  __typename?: 'ZRM_QuickResponses';
  prediction?: Maybe<Scalars['String']>;
  suggestions?: Maybe<Array<Maybe<Zrm_QuickResponses_Suggestions>>>;
};

export type Zrm_QuickResponses_Suggestions = {
  __typename?: 'ZRM_QuickResponses_Suggestions';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Zrm_RentalProtection = {
  __typename?: 'ZRM_RentalProtection';
  isEligible?: Maybe<Scalars['Boolean']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  relativePath?: Maybe<Scalars['String']>;
};

export type Zrm_RenterProfile = {
  __typename?: 'ZRM_RenterProfile';
  attributes?: Maybe<Zrm_RenterProfile_Attributes>;
  isRenterProfileHidden?: Maybe<Scalars['Boolean']>;
  leadIntentValue?: Maybe<Scalars['String']>;
  renterProfileCompleteness?: Maybe<Scalars['String']>;
  shouldShowRequestRenterProfileCta?: Maybe<Scalars['Boolean']>;
};

export type Zrm_RenterProfile_Attributes = {
  __typename?: 'ZRM_RenterProfile_Attributes';
  credit?: Maybe<Scalars['String']>;
  desiredParking?: Maybe<Scalars['String']>;
  incomeYearly?: Maybe<Scalars['String']>;
  incomeYearlyRange?: Maybe<Scalars['String']>;
  introduction?: Maybe<Scalars['String']>;
  isSmoker?: Maybe<Scalars['String']>;
  isSmokerBoolean?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  leaseLengthMonths?: Maybe<Scalars['String']>;
  moveInDate?: Maybe<Scalars['String']>;
  numBedrooms?: Maybe<Scalars['String']>;
  numOccupants?: Maybe<Scalars['String']>;
  petDetails?: Maybe<Array<Maybe<Zrm_RenterProfile_PetDetails>>>;
  reasonForMoving?: Maybe<Scalars['String']>;
  updatedAtMs?: Maybe<Scalars['String']>;
  voucherAmountMonthly?: Maybe<Scalars['String']>;
};

export type Zrm_RenterProfile_PetDetails = {
  __typename?: 'ZRM_RenterProfile_PetDetails';
  breed?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  weightPounds?: Maybe<Scalars['String']>;
};

export type Zrm_RenterResume = {
  __typename?: 'ZRM_RenterResume';
  credit?: Maybe<Scalars['String']>;
  desiredParking?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  income?: Maybe<Scalars['String']>;
  introduction?: Maybe<Scalars['String']>;
  isSmoker?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  leaseLengthMonths?: Maybe<Scalars['String']>;
  moveInTimeframe?: Maybe<Scalars['String']>;
  numOccupants?: Maybe<Scalars['String']>;
  pets?: Maybe<Array<Maybe<Scalars['String']>>>;
  reasonForMoving?: Maybe<Scalars['String']>;
  updatedAtMs?: Maybe<Scalars['String']>;
};

export type Zrm_RentGuarantee = {
  __typename?: 'ZRM_RentGuarantee';
  isEligible?: Maybe<Scalars['Boolean']>;
};

export type Zrm_Restrictions = {
  __typename?: 'ZRM_Restrictions';
  ctaText?: Maybe<Scalars['String']>;
  ctaUrl?: Maybe<Scalars['String']>;
  isAllowed?: Maybe<Scalars['Boolean']>;
  messageCode?: Maybe<Scalars['String']>;
  partialMessages?: Maybe<Array<Maybe<Zrm_PartialMessages>>>;
  title?: Maybe<Scalars['String']>;
};

export type Zrm_SatelliteWebCheckInfo = {
  __typename?: 'ZRM_satelliteWebCheckInfo';
  buildNumber?: Maybe<Scalars['Int']>;
  host?: Maybe<Scalars['String']>;
  nodeEnv?: Maybe<Scalars['String']>;
  zgApi?: Maybe<Scalars['String']>;
};

export type Zrm_StatusLabel = {
  __typename?: 'ZRM_StatusLabel';
  linkData?: Maybe<Scalars['String']>;
  linkId: Scalars['String'];
  text: Scalars['String'];
};

export type Zrm_SuccessStatusResponse = {
  __typename?: 'ZRM_SuccessStatusResponse';
  success: Scalars['Boolean'];
};

export type Zrm_Summary = {
  __typename?: 'ZRM_Summary';
  activeListingCount?: Maybe<Scalars['Int']>;
  totalListingCount?: Maybe<Scalars['Int']>;
};

export type Zrm_Touring = {
  __typename?: 'ZRM_Touring';
  hasZrmToursEnabled: Scalars['Boolean'];
};

export type UserAuthenticationFragment = {
  __typename?: 'User';
  loggedIn: boolean;
  userToken?: Maybe<string>;
  hasStrongAuthentication?: Maybe<boolean>;
  encodedZuid?: Maybe<string>;
  impersonatorEmail?: Maybe<string>;
  impersonatorUserToken?: Maybe<string>;
  isTwoFactorAuthEnabled?: Maybe<boolean>;
  isTwoFactorAuthenticated?: Maybe<boolean>;
};

export type UserInfoFragment = {
  __typename?: 'User';
  applicationsEnabled: boolean;
  paymentsAccessAllowed: boolean;
  isMultifamilyCustomer: boolean;
  isUserBlocked?: Maybe<boolean>;
  isLeasingBeta: boolean;
  isEmailVerified?: Maybe<boolean>;
  isPostingPathAdmin?: Maybe<boolean>;
  isSingleFamilyEnterpriseCustomer?: Maybe<boolean>;
  roles?: Maybe<Array<string>>;
  phoneNumber?: Maybe<string>;
  email?: Maybe<string>;
  firstName?: Maybe<string>;
  lastName?: Maybe<string>;
  restrictions?: Maybe<{
    __typename?: 'ZRM_Restrictions';
    ctaText?: Maybe<string>;
    ctaUrl?: Maybe<string>;
    isAllowed?: Maybe<boolean>;
    messageCode?: Maybe<string>;
    title?: Maybe<string>;
    partialMessages?: Maybe<
      Array<
        Maybe<{
          __typename?: 'ZRM_PartialMessages';
          isBold?: Maybe<boolean>;
          text?: Maybe<string>;
          url?: Maybe<string>;
          className?: Maybe<string>;
        }>
      >
    >;
  }>;
  summary?: Maybe<{
    __typename?: 'ZRM_Summary';
    activeListingCount?: Maybe<number>;
    totalListingCount?: Maybe<number>;
  }>;
};

export type AuthCheckWrapper_GetHotPadsUserQueryVariables = Exact<{ [key: string]: never }>;

export type AuthCheckWrapper_GetHotPadsUserQuery = {
  __typename?: 'Query';
  RH_getHotpadsUser: {
    __typename?: 'User';
    loggedIn: boolean;
    userToken?: Maybe<string>;
    hasStrongAuthentication?: Maybe<boolean>;
    encodedZuid?: Maybe<string>;
    impersonatorEmail?: Maybe<string>;
    impersonatorUserToken?: Maybe<string>;
    isTwoFactorAuthEnabled?: Maybe<boolean>;
    isTwoFactorAuthenticated?: Maybe<boolean>;
    applicationsEnabled: boolean;
    paymentsAccessAllowed: boolean;
    isMultifamilyCustomer: boolean;
    isUserBlocked?: Maybe<boolean>;
    isLeasingBeta: boolean;
    isEmailVerified?: Maybe<boolean>;
    isPostingPathAdmin?: Maybe<boolean>;
    isSingleFamilyEnterpriseCustomer?: Maybe<boolean>;
    roles?: Maybe<Array<string>>;
    phoneNumber?: Maybe<string>;
    email?: Maybe<string>;
    firstName?: Maybe<string>;
    lastName?: Maybe<string>;
    restrictions?: Maybe<{
      __typename?: 'ZRM_Restrictions';
      ctaText?: Maybe<string>;
      ctaUrl?: Maybe<string>;
      isAllowed?: Maybe<boolean>;
      messageCode?: Maybe<string>;
      title?: Maybe<string>;
      partialMessages?: Maybe<
        Array<
          Maybe<{
            __typename?: 'ZRM_PartialMessages';
            isBold?: Maybe<boolean>;
            text?: Maybe<string>;
            url?: Maybe<string>;
            className?: Maybe<string>;
          }>
        >
      >;
    }>;
    summary?: Maybe<{
      __typename?: 'ZRM_Summary';
      activeListingCount?: Maybe<number>;
      totalListingCount?: Maybe<number>;
    }>;
  };
};

export type AuthCheckWrapper_GetZillowUserQueryVariables = Exact<{ [key: string]: never }>;

export type AuthCheckWrapper_GetZillowUserQuery = {
  __typename?: 'Query';
  RH_getZillowUser: {
    __typename?: 'User';
    loggedIn: boolean;
    userToken?: Maybe<string>;
    hasStrongAuthentication?: Maybe<boolean>;
    encodedZuid?: Maybe<string>;
    impersonatorEmail?: Maybe<string>;
    impersonatorUserToken?: Maybe<string>;
    isTwoFactorAuthEnabled?: Maybe<boolean>;
    isTwoFactorAuthenticated?: Maybe<boolean>;
    applicationsEnabled: boolean;
    paymentsAccessAllowed: boolean;
    isMultifamilyCustomer: boolean;
    isUserBlocked?: Maybe<boolean>;
    isLeasingBeta: boolean;
    isEmailVerified?: Maybe<boolean>;
    isPostingPathAdmin?: Maybe<boolean>;
    isSingleFamilyEnterpriseCustomer?: Maybe<boolean>;
    roles?: Maybe<Array<string>>;
    phoneNumber?: Maybe<string>;
    email?: Maybe<string>;
    firstName?: Maybe<string>;
    lastName?: Maybe<string>;
    restrictions?: Maybe<{
      __typename?: 'ZRM_Restrictions';
      ctaText?: Maybe<string>;
      ctaUrl?: Maybe<string>;
      isAllowed?: Maybe<boolean>;
      messageCode?: Maybe<string>;
      title?: Maybe<string>;
      partialMessages?: Maybe<
        Array<
          Maybe<{
            __typename?: 'ZRM_PartialMessages';
            isBold?: Maybe<boolean>;
            text?: Maybe<string>;
            url?: Maybe<string>;
            className?: Maybe<string>;
          }>
        >
      >;
    }>;
    summary?: Maybe<{
      __typename?: 'ZRM_Summary';
      activeListingCount?: Maybe<number>;
      totalListingCount?: Maybe<number>;
    }>;
  };
};

export type ConversationList_Rh_GetLatestConversationsQueryVariables = Exact<{
  paginationStartIndex?: Maybe<Scalars['String']>;
  folder?: Maybe<Folder>;
  daysBack?: Maybe<Scalars['Int']>;
}>;

export type ConversationList_Rh_GetLatestConversationsQuery = {
  __typename?: 'Query';
  RH_getLatestConversations: {
    __typename?: 'RH_ConversationResponse';
    conversations: Array<{
      __typename?: 'RH_Conversation';
      conversationId?: Maybe<string>;
      hasUnreadMessage: boolean;
      referenceName?: Maybe<string>;
      landlordName?: Maybe<string>;
      listingName?: Maybe<string>;
      address?: Maybe<string>;
      photoUrl?: Maybe<string>;
      conversation: Array<{
        __typename?: 'RH_Message';
        isMessageOwner?: Maybe<boolean>;
        conversationId?: Maybe<string>;
        message?: Maybe<string>;
        messageDateMs: string;
        messageId?: Maybe<string>;
        messageType: string;
        senderName?: Maybe<string>;
      }>;
      status: { __typename?: 'RH_ConversationStatus'; isSpam: boolean; isArchived: boolean };
    }>;
    pagination?: Maybe<{ __typename?: 'RH_Pagination'; pageStartIndex?: Maybe<number>; hasNextPage?: Maybe<boolean> }>;
  };
};

export type ConversationNav_Rh_UpdateConversationStatusMutationVariables = Exact<{
  conversationId: Scalars['String'];
  isArchived?: Maybe<Scalars['Boolean']>;
  reportReasonType?: Maybe<ReportConversationReason>;
  userReportComment?: Maybe<Scalars['String']>;
}>;

export type ConversationNav_Rh_UpdateConversationStatusMutation = {
  __typename?: 'Mutation';
  RH_updateConversationStatusV2: { __typename?: 'RH_SuccessStatusResponse'; success: boolean };
};

export type ConversationNav_Rh_GetConversationByIdQueryVariables = Exact<{
  conversationId: Scalars['String'];
}>;

export type ConversationNav_Rh_GetConversationByIdQuery = {
  __typename?: 'Query';
  RH_getConversationById: {
    __typename?: 'RH_Conversation';
    acceptsReplies?: Maybe<boolean>;
    acceptsRepliesExplanation?: Maybe<string>;
    address?: Maybe<string>;
    conversationId?: Maybe<string>;
    isActive: boolean;
    propertyTypeCode?: Maybe<number>;
    referenceName?: Maybe<string>;
    referenceEmail?: Maybe<string>;
    photoUrl?: Maybe<string>;
    beds?: Maybe<string>;
    pricing?: Maybe<string>;
    landlordName?: Maybe<string>;
    isApplicationEnabledByLandlord?: Maybe<boolean>;
    isApplicationsAllowed?: Maybe<boolean>;
    isConversationBlockedByZillow: boolean;
    encodedAlias?: Maybe<string>;
    listingAlias?: Maybe<string>;
    listingName?: Maybe<string>;
    numBathroomsHigh?: Maybe<string>;
    isMultifamily?: Maybe<boolean>;
    pricingDisplay?: Maybe<RenterHubApiTotalMonthlyPriceDisplayType>;
    application?: Maybe<{ __typename?: 'RH_Application'; applicationId?: Maybe<string> }>;
    addressDetails?: Maybe<{ __typename?: 'RH_AddressDetails'; stateAbbrev?: Maybe<string> }>;
    pricingDetails?: Maybe<{
      __typename?: 'RH_PricingDetails';
      isHasBaseRentAndFees: boolean;
      baseRentMin?: Maybe<number>;
      baseRentMax?: Maybe<number>;
      totalRequiredMonthlyFeeMin?: Maybe<number>;
      totalRequiredMonthlyFeeMax?: Maybe<number>;
    }>;
  };
};

export type ConversationDataFragment = {
  __typename?: 'RH_Conversation';
  acceptsReplies?: Maybe<boolean>;
  acceptsRepliesExplanation?: Maybe<string>;
  conversationId?: Maybe<string>;
  hasUnreadMessage: boolean;
  isConversationBlockedByZillow: boolean;
  listingAlias?: Maybe<string>;
  conversation: Array<{
    __typename?: 'RH_Message';
    aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
    isMessageOwner?: Maybe<boolean>;
    conversationId?: Maybe<string>;
    message?: Maybe<string>;
    messageDateMs: string;
    messageId?: Maybe<string>;
    messageType: string;
    senderName?: Maybe<string>;
    uiTreatmentType?: Maybe<string>;
    title?: Maybe<string>;
    attachments: Array<{
      __typename?: 'RH_Attachment';
      attachmentMetadataStatus?: Maybe<string>;
      downloadUrl?: Maybe<string>;
      fileName?: Maybe<string>;
      fileSizeBytes?: Maybe<number>;
      fileType?: Maybe<string>;
      isAttachmentDeleted?: Maybe<boolean>;
      isAttachmentExpired?: Maybe<boolean>;
      previewUrl?: Maybe<string>;
      zDocId?: Maybe<string>;
    }>;
    messageLink?: Maybe<{ __typename?: 'ZRM_CTA_Link'; url?: Maybe<string>; text: string }>;
  }>;
  disclaimers?: Maybe<{
    __typename?: 'RH_Disclaimers';
    ai: {
      __typename?: 'RH_Disclaimer';
      disclaimerText: string;
      links?: Maybe<
        Array<Maybe<{ __typename?: 'RH_DisclaimerLink'; textToDisplay: string; textToReplace: string; url: string }>>
      >;
      emailLinks?: Maybe<
        Array<
          Maybe<{
            __typename?: 'RH_DisclaimerEmailLink';
            emailAddress: string;
            textToDisplay: string;
            textToReplace: string;
          }>
        >
      >;
    };
  }>;
  pagination?: Maybe<{
    __typename?: 'RH_Pagination';
    pageConversationCount?: Maybe<number>;
    pageStartIndex?: Maybe<number>;
  }>;
};

export type MessageList_Rh_UpdateConversationStatusMutationVariables = Exact<{
  conversationId: Scalars['String'];
  lastReadMs: Scalars['String'];
}>;

export type MessageList_Rh_UpdateConversationStatusMutation = {
  __typename?: 'Mutation';
  RH_updateConversationStatus?: Maybe<{ __typename?: 'RH_SuccessStatusResponse'; success: boolean }>;
};

export type MessageList_Rh_GetConversationQueryVariables = Exact<{
  conversationId: Scalars['String'];
  paginationStartIndex?: Maybe<Scalars['String']>;
}>;

export type MessageList_Rh_GetConversationQuery = {
  __typename?: 'Query';
  RH_getConversationById: {
    __typename?: 'RH_Conversation';
    acceptsReplies?: Maybe<boolean>;
    acceptsRepliesExplanation?: Maybe<string>;
    conversationId?: Maybe<string>;
    hasUnreadMessage: boolean;
    isConversationBlockedByZillow: boolean;
    listingAlias?: Maybe<string>;
    conversation: Array<{
      __typename?: 'RH_Message';
      aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
      isMessageOwner?: Maybe<boolean>;
      conversationId?: Maybe<string>;
      message?: Maybe<string>;
      messageDateMs: string;
      messageId?: Maybe<string>;
      messageType: string;
      senderName?: Maybe<string>;
      uiTreatmentType?: Maybe<string>;
      title?: Maybe<string>;
      attachments: Array<{
        __typename?: 'RH_Attachment';
        attachmentMetadataStatus?: Maybe<string>;
        downloadUrl?: Maybe<string>;
        fileName?: Maybe<string>;
        fileSizeBytes?: Maybe<number>;
        fileType?: Maybe<string>;
        isAttachmentDeleted?: Maybe<boolean>;
        isAttachmentExpired?: Maybe<boolean>;
        previewUrl?: Maybe<string>;
        zDocId?: Maybe<string>;
      }>;
      messageLink?: Maybe<{ __typename?: 'ZRM_CTA_Link'; url?: Maybe<string>; text: string }>;
    }>;
    disclaimers?: Maybe<{
      __typename?: 'RH_Disclaimers';
      ai: {
        __typename?: 'RH_Disclaimer';
        disclaimerText: string;
        links?: Maybe<
          Array<Maybe<{ __typename?: 'RH_DisclaimerLink'; textToDisplay: string; textToReplace: string; url: string }>>
        >;
        emailLinks?: Maybe<
          Array<
            Maybe<{
              __typename?: 'RH_DisclaimerEmailLink';
              emailAddress: string;
              textToDisplay: string;
              textToReplace: string;
            }>
          >
        >;
      };
    }>;
    pagination?: Maybe<{
      __typename?: 'RH_Pagination';
      pageConversationCount?: Maybe<number>;
      pageStartIndex?: Maybe<number>;
    }>;
  };
};

export type NoConversationsContent_GetLatestConversationsQueryVariables = Exact<{
  folder?: Maybe<Folder>;
  daysBack?: Maybe<Scalars['Int']>;
}>;

export type NoConversationsContent_GetLatestConversationsQuery = {
  __typename?: 'Query';
  RH_getLatestConversations: {
    __typename?: 'RH_ConversationResponse';
    conversations: Array<{ __typename?: 'RH_Conversation'; conversationId?: Maybe<string> }>;
  };
};

export type Rh_RequestToApplyMutationVariables = Exact<{
  alias?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  requestToApply?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
}>;

export type Rh_RequestToApplyMutation = {
  __typename?: 'Mutation';
  RH_RequestToApply: { __typename?: 'RH_RequestToApplyResponse'; status?: Maybe<string>; success?: Maybe<boolean> };
};

export type InboxPage_Rh_UpdateConversationStatusMutationVariables = Exact<{
  conversationId: Scalars['String'];
  isArchived?: Maybe<Scalars['Boolean']>;
  reportReasonType?: Maybe<ReportConversationReason>;
}>;

export type InboxPage_Rh_UpdateConversationStatusMutation = {
  __typename?: 'Mutation';
  RH_updateConversationStatusV2: { __typename?: 'RH_SuccessStatusResponse'; success: boolean };
};

export type Rh_GetSyndicationUrlsQueryVariables = Exact<{
  listingAlias: Scalars['String'];
  fetchZillow: Scalars['Boolean'];
  fetchHotpads: Scalars['Boolean'];
  fetchTrulia: Scalars['Boolean'];
}>;

export type Rh_GetSyndicationUrlsQuery = {
  __typename?: 'Query';
  RH_getSyndicationUrls?: Maybe<{
    __typename?: 'RH_SyndicationUrls';
    hotpadsUrl?: Maybe<string>;
    zillowUrl?: Maybe<string>;
    truliaUrl?: Maybe<string>;
  }>;
};

export type InboxPage_Rh_FetchConversationIdQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  folder?: Maybe<Folder>;
}>;

export type InboxPage_Rh_FetchConversationIdQuery = {
  __typename?: 'Query';
  RH_getLatestConversations: {
    __typename?: 'RH_ConversationResponse';
    conversations: Array<{ __typename?: 'RH_Conversation'; conversationId?: Maybe<string> }>;
  };
};

export type InquiryPage_Rh_GetConversationForInquiryIdQueryVariables = Exact<{
  inquiryId: Scalars['String'];
}>;

export type InquiryPage_Rh_GetConversationForInquiryIdQuery = {
  __typename?: 'Query';
  RH_getAllForInquiryId: {
    __typename?: 'RH_Conversation';
    acceptsReplies?: Maybe<boolean>;
    acceptsRepliesExplanation?: Maybe<string>;
    conversationId?: Maybe<string>;
    hasUnreadMessage: boolean;
    isConversationBlockedByZillow: boolean;
    listingAlias?: Maybe<string>;
    conversation: Array<{
      __typename?: 'RH_Message';
      aiAutoResponseType?: Maybe<SatelliteAiAutoResponseType>;
      isMessageOwner?: Maybe<boolean>;
      conversationId?: Maybe<string>;
      message?: Maybe<string>;
      messageDateMs: string;
      messageId?: Maybe<string>;
      messageType: string;
      senderName?: Maybe<string>;
      uiTreatmentType?: Maybe<string>;
      title?: Maybe<string>;
      attachments: Array<{
        __typename?: 'RH_Attachment';
        attachmentMetadataStatus?: Maybe<string>;
        downloadUrl?: Maybe<string>;
        fileName?: Maybe<string>;
        fileSizeBytes?: Maybe<number>;
        fileType?: Maybe<string>;
        isAttachmentDeleted?: Maybe<boolean>;
        isAttachmentExpired?: Maybe<boolean>;
        previewUrl?: Maybe<string>;
        zDocId?: Maybe<string>;
      }>;
      messageLink?: Maybe<{ __typename?: 'ZRM_CTA_Link'; url?: Maybe<string>; text: string }>;
    }>;
    disclaimers?: Maybe<{
      __typename?: 'RH_Disclaimers';
      ai: {
        __typename?: 'RH_Disclaimer';
        disclaimerText: string;
        links?: Maybe<
          Array<Maybe<{ __typename?: 'RH_DisclaimerLink'; textToDisplay: string; textToReplace: string; url: string }>>
        >;
        emailLinks?: Maybe<
          Array<
            Maybe<{
              __typename?: 'RH_DisclaimerEmailLink';
              emailAddress: string;
              textToDisplay: string;
              textToReplace: string;
            }>
          >
        >;
      };
    }>;
    pagination?: Maybe<{
      __typename?: 'RH_Pagination';
      pageConversationCount?: Maybe<number>;
      pageStartIndex?: Maybe<number>;
    }>;
  };
};

export type InboxRhPage_GetFeatureFlagsAndSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type InboxRhPage_GetFeatureFlagsAndSettingsQuery = {
  __typename?: 'Query';
  getFeatureFlagsAndSettings?: Maybe<{
    __typename?: 'FeatureFlagsAndSettingsResponse';
    features?: Maybe<{
      __typename?: 'FeatureFlagResponse';
      enableExternalLinkWarningModal?: Maybe<boolean>;
      canAccessBlockedUserModalFromRJSModule?: Maybe<boolean>;
      enableWebsocketForRachelInbox?: Maybe<boolean>;
      enableInboxIA?: Maybe<boolean>;
      enableMessageLink?: Maybe<boolean>;
      enablePersonalInfoWarningModal?: Maybe<boolean>;
      enableRentingBuyingPills?: Maybe<boolean>;
      enableTMP?: Maybe<boolean>;
    }>;
    settings?: Maybe<{
      __typename?: 'SettingsResponse';
      aiConversationPollIntervalInSeconds?: Maybe<number>;
      abTreatmentForTMP?: Maybe<string>;
    }>;
  }>;
};

export const UserAuthenticationFragmentDoc = gql`
  fragment userAuthentication on User {
    loggedIn
    userToken
    hasStrongAuthentication
    encodedZuid
    impersonatorEmail
    impersonatorUserToken
    isTwoFactorAuthEnabled
    isTwoFactorAuthenticated
  }
`;
export const UserInfoFragmentDoc = gql`
  fragment userInfo on User {
    applicationsEnabled
    paymentsAccessAllowed
    isMultifamilyCustomer
    isUserBlocked
    isLeasingBeta
    isEmailVerified
    isPostingPathAdmin
    isSingleFamilyEnterpriseCustomer
    roles
    phoneNumber
    email
    firstName
    lastName
    restrictions {
      ctaText
      ctaUrl
      isAllowed
      messageCode
      partialMessages {
        isBold
        text
        url
        className
      }
      title
    }
    summary {
      activeListingCount
      totalListingCount
    }
  }
`;
export const ConversationDataFragmentDoc = gql`
  fragment ConversationData on RH_Conversation {
    acceptsReplies
    acceptsRepliesExplanation
    conversationId
    hasUnreadMessage
    conversation {
      aiAutoResponseType
      attachments {
        attachmentMetadataStatus
        downloadUrl
        fileName
        fileSizeBytes
        fileType
        isAttachmentDeleted
        isAttachmentExpired
        previewUrl
        zDocId
      }
      isMessageOwner
      conversationId
      message
      messageDateMs
      messageId
      messageType
      senderName
      messageLink {
        url
        text
      }
      uiTreatmentType
      title
    }
    disclaimers {
      ai {
        disclaimerText
        links {
          textToDisplay
          textToReplace
          url
        }
        emailLinks {
          emailAddress
          textToDisplay
          textToReplace
        }
      }
    }
    isConversationBlockedByZillow
    listingAlias
    pagination {
      pageConversationCount
      pageStartIndex
    }
  }
`;
export const AuthCheckWrapper_GetHotPadsUserDocument = gql`
  query AuthCheckWrapper_getHotPadsUser {
    RH_getHotpadsUser {
      ...userAuthentication
      ...userInfo
    }
  }
  ${UserAuthenticationFragmentDoc}
  ${UserInfoFragmentDoc}
`;

/**
 * __useAuthCheckWrapper_GetHotPadsUserQuery__
 *
 * To run a query within a React component, call `useAuthCheckWrapper_GetHotPadsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthCheckWrapper_GetHotPadsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthCheckWrapper_GetHotPadsUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthCheckWrapper_GetHotPadsUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AuthCheckWrapper_GetHotPadsUserQuery,
    AuthCheckWrapper_GetHotPadsUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AuthCheckWrapper_GetHotPadsUserQuery, AuthCheckWrapper_GetHotPadsUserQueryVariables>(
    AuthCheckWrapper_GetHotPadsUserDocument,
    options,
  );
}
export function useAuthCheckWrapper_GetHotPadsUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthCheckWrapper_GetHotPadsUserQuery,
    AuthCheckWrapper_GetHotPadsUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AuthCheckWrapper_GetHotPadsUserQuery, AuthCheckWrapper_GetHotPadsUserQueryVariables>(
    AuthCheckWrapper_GetHotPadsUserDocument,
    options,
  );
}
export type AuthCheckWrapper_GetHotPadsUserQueryHookResult = ReturnType<typeof useAuthCheckWrapper_GetHotPadsUserQuery>;
export type AuthCheckWrapper_GetHotPadsUserLazyQueryHookResult = ReturnType<
  typeof useAuthCheckWrapper_GetHotPadsUserLazyQuery
>;
export function refetchAuthCheckWrapper_GetHotPadsUserQuery(variables?: AuthCheckWrapper_GetHotPadsUserQueryVariables) {
  return { query: AuthCheckWrapper_GetHotPadsUserDocument, variables: variables };
}
export const AuthCheckWrapper_GetZillowUserDocument = gql`
  query AuthCheckWrapper_getZillowUser {
    RH_getZillowUser {
      ...userAuthentication
      ...userInfo
    }
  }
  ${UserAuthenticationFragmentDoc}
  ${UserInfoFragmentDoc}
`;

/**
 * __useAuthCheckWrapper_GetZillowUserQuery__
 *
 * To run a query within a React component, call `useAuthCheckWrapper_GetZillowUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthCheckWrapper_GetZillowUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthCheckWrapper_GetZillowUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthCheckWrapper_GetZillowUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AuthCheckWrapper_GetZillowUserQuery,
    AuthCheckWrapper_GetZillowUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AuthCheckWrapper_GetZillowUserQuery, AuthCheckWrapper_GetZillowUserQueryVariables>(
    AuthCheckWrapper_GetZillowUserDocument,
    options,
  );
}
export function useAuthCheckWrapper_GetZillowUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthCheckWrapper_GetZillowUserQuery,
    AuthCheckWrapper_GetZillowUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AuthCheckWrapper_GetZillowUserQuery, AuthCheckWrapper_GetZillowUserQueryVariables>(
    AuthCheckWrapper_GetZillowUserDocument,
    options,
  );
}
export type AuthCheckWrapper_GetZillowUserQueryHookResult = ReturnType<typeof useAuthCheckWrapper_GetZillowUserQuery>;
export type AuthCheckWrapper_GetZillowUserLazyQueryHookResult = ReturnType<
  typeof useAuthCheckWrapper_GetZillowUserLazyQuery
>;
export function refetchAuthCheckWrapper_GetZillowUserQuery(variables?: AuthCheckWrapper_GetZillowUserQueryVariables) {
  return { query: AuthCheckWrapper_GetZillowUserDocument, variables: variables };
}
export const ConversationList_Rh_GetLatestConversationsDocument = gql`
  query ConversationList_RH_getLatestConversations($paginationStartIndex: String, $folder: Folder, $daysBack: Int) {
    RH_getLatestConversations(paginationStartIndex: $paginationStartIndex, folder: $folder, daysBack: $daysBack) {
      conversations {
        conversation {
          isMessageOwner
          conversationId
          message
          messageDateMs
          messageId
          messageType
          senderName
        }
        status {
          isSpam
          isArchived
        }
        conversationId
        hasUnreadMessage
        referenceName
        landlordName
        listingName
        address
        photoUrl
      }
      pagination {
        pageStartIndex
        hasNextPage
      }
    }
  }
`;

/**
 * __useConversationList_Rh_GetLatestConversationsQuery__
 *
 * To run a query within a React component, call `useConversationList_Rh_GetLatestConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationList_Rh_GetLatestConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationList_Rh_GetLatestConversationsQuery({
 *   variables: {
 *      paginationStartIndex: // value for 'paginationStartIndex'
 *      folder: // value for 'folder'
 *      daysBack: // value for 'daysBack'
 *   },
 * });
 */
export function useConversationList_Rh_GetLatestConversationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ConversationList_Rh_GetLatestConversationsQuery,
    ConversationList_Rh_GetLatestConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConversationList_Rh_GetLatestConversationsQuery,
    ConversationList_Rh_GetLatestConversationsQueryVariables
  >(ConversationList_Rh_GetLatestConversationsDocument, options);
}
export function useConversationList_Rh_GetLatestConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConversationList_Rh_GetLatestConversationsQuery,
    ConversationList_Rh_GetLatestConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConversationList_Rh_GetLatestConversationsQuery,
    ConversationList_Rh_GetLatestConversationsQueryVariables
  >(ConversationList_Rh_GetLatestConversationsDocument, options);
}
export type ConversationList_Rh_GetLatestConversationsQueryHookResult = ReturnType<
  typeof useConversationList_Rh_GetLatestConversationsQuery
>;
export type ConversationList_Rh_GetLatestConversationsLazyQueryHookResult = ReturnType<
  typeof useConversationList_Rh_GetLatestConversationsLazyQuery
>;
export function refetchConversationList_Rh_GetLatestConversationsQuery(
  variables?: ConversationList_Rh_GetLatestConversationsQueryVariables,
) {
  return { query: ConversationList_Rh_GetLatestConversationsDocument, variables: variables };
}
export const ConversationNav_Rh_UpdateConversationStatusDocument = gql`
  mutation ConversationNav_RH_updateConversationStatus(
    $conversationId: String!
    $isArchived: Boolean
    $reportReasonType: ReportConversationReason
    $userReportComment: String
  ) {
    RH_updateConversationStatusV2(
      conversationId: $conversationId
      isArchived: $isArchived
      reportReasonType: $reportReasonType
      userReportComment: $userReportComment
    ) {
      success
    }
  }
`;
export type ConversationNav_Rh_UpdateConversationStatusMutationFn = Apollo.MutationFunction<
  ConversationNav_Rh_UpdateConversationStatusMutation,
  ConversationNav_Rh_UpdateConversationStatusMutationVariables
>;

/**
 * __useConversationNav_Rh_UpdateConversationStatusMutation__
 *
 * To run a mutation, you first call `useConversationNav_Rh_UpdateConversationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConversationNav_Rh_UpdateConversationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [conversationNavRhUpdateConversationStatusMutation, { data, loading, error }] = useConversationNav_Rh_UpdateConversationStatusMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      isArchived: // value for 'isArchived'
 *      reportReasonType: // value for 'reportReasonType'
 *      userReportComment: // value for 'userReportComment'
 *   },
 * });
 */
export function useConversationNav_Rh_UpdateConversationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConversationNav_Rh_UpdateConversationStatusMutation,
    ConversationNav_Rh_UpdateConversationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConversationNav_Rh_UpdateConversationStatusMutation,
    ConversationNav_Rh_UpdateConversationStatusMutationVariables
  >(ConversationNav_Rh_UpdateConversationStatusDocument, options);
}
export type ConversationNav_Rh_UpdateConversationStatusMutationHookResult = ReturnType<
  typeof useConversationNav_Rh_UpdateConversationStatusMutation
>;
export type ConversationNav_Rh_UpdateConversationStatusMutationOptions = Apollo.BaseMutationOptions<
  ConversationNav_Rh_UpdateConversationStatusMutation,
  ConversationNav_Rh_UpdateConversationStatusMutationVariables
>;
export const ConversationNav_Rh_GetConversationByIdDocument = gql`
  query ConversationNav_RH_getConversationById($conversationId: String!) {
    RH_getConversationById(conversationId: $conversationId) {
      acceptsReplies
      acceptsRepliesExplanation
      address
      conversationId
      isActive
      propertyTypeCode
      referenceName
      referenceEmail
      photoUrl
      beds
      pricing
      landlordName
      isApplicationEnabledByLandlord
      isApplicationsAllowed
      isConversationBlockedByZillow
      encodedAlias
      listingAlias
      listingName
      numBathroomsHigh
      isMultifamily
      application {
        applicationId
      }
      addressDetails {
        stateAbbrev
      }
      pricingDetails {
        isHasBaseRentAndFees
        baseRentMin
        baseRentMax
        totalRequiredMonthlyFeeMin
        totalRequiredMonthlyFeeMax
      }
      pricingDisplay
    }
  }
`;

/**
 * __useConversationNav_Rh_GetConversationByIdQuery__
 *
 * To run a query within a React component, call `useConversationNav_Rh_GetConversationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationNav_Rh_GetConversationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationNav_Rh_GetConversationByIdQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationNav_Rh_GetConversationByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConversationNav_Rh_GetConversationByIdQuery,
    ConversationNav_Rh_GetConversationByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConversationNav_Rh_GetConversationByIdQuery,
    ConversationNav_Rh_GetConversationByIdQueryVariables
  >(ConversationNav_Rh_GetConversationByIdDocument, options);
}
export function useConversationNav_Rh_GetConversationByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConversationNav_Rh_GetConversationByIdQuery,
    ConversationNav_Rh_GetConversationByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConversationNav_Rh_GetConversationByIdQuery,
    ConversationNav_Rh_GetConversationByIdQueryVariables
  >(ConversationNav_Rh_GetConversationByIdDocument, options);
}
export type ConversationNav_Rh_GetConversationByIdQueryHookResult = ReturnType<
  typeof useConversationNav_Rh_GetConversationByIdQuery
>;
export type ConversationNav_Rh_GetConversationByIdLazyQueryHookResult = ReturnType<
  typeof useConversationNav_Rh_GetConversationByIdLazyQuery
>;
export function refetchConversationNav_Rh_GetConversationByIdQuery(
  variables?: ConversationNav_Rh_GetConversationByIdQueryVariables,
) {
  return { query: ConversationNav_Rh_GetConversationByIdDocument, variables: variables };
}
export const MessageList_Rh_UpdateConversationStatusDocument = gql`
  mutation MessageList_RH_updateConversationStatus($conversationId: String!, $lastReadMs: String!) {
    RH_updateConversationStatus(conversationId: $conversationId, lastReadMs: $lastReadMs) {
      success
    }
  }
`;
export type MessageList_Rh_UpdateConversationStatusMutationFn = Apollo.MutationFunction<
  MessageList_Rh_UpdateConversationStatusMutation,
  MessageList_Rh_UpdateConversationStatusMutationVariables
>;

/**
 * __useMessageList_Rh_UpdateConversationStatusMutation__
 *
 * To run a mutation, you first call `useMessageList_Rh_UpdateConversationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageList_Rh_UpdateConversationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageListRhUpdateConversationStatusMutation, { data, loading, error }] = useMessageList_Rh_UpdateConversationStatusMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      lastReadMs: // value for 'lastReadMs'
 *   },
 * });
 */
export function useMessageList_Rh_UpdateConversationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MessageList_Rh_UpdateConversationStatusMutation,
    MessageList_Rh_UpdateConversationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MessageList_Rh_UpdateConversationStatusMutation,
    MessageList_Rh_UpdateConversationStatusMutationVariables
  >(MessageList_Rh_UpdateConversationStatusDocument, options);
}
export type MessageList_Rh_UpdateConversationStatusMutationHookResult = ReturnType<
  typeof useMessageList_Rh_UpdateConversationStatusMutation
>;
export type MessageList_Rh_UpdateConversationStatusMutationOptions = Apollo.BaseMutationOptions<
  MessageList_Rh_UpdateConversationStatusMutation,
  MessageList_Rh_UpdateConversationStatusMutationVariables
>;
export const MessageList_Rh_GetConversationDocument = gql`
  query MessageList_RH_GetConversation($conversationId: String!, $paginationStartIndex: String) {
    RH_getConversationById(
      conversationId: $conversationId
      includeAttachmentsMetadata: true
      paginationStartIndex: $paginationStartIndex
    ) {
      ...ConversationData
    }
  }
  ${ConversationDataFragmentDoc}
`;

/**
 * __useMessageList_Rh_GetConversationQuery__
 *
 * To run a query within a React component, call `useMessageList_Rh_GetConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageList_Rh_GetConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageList_Rh_GetConversationQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      paginationStartIndex: // value for 'paginationStartIndex'
 *   },
 * });
 */
export function useMessageList_Rh_GetConversationQuery(
  baseOptions: Apollo.QueryHookOptions<
    MessageList_Rh_GetConversationQuery,
    MessageList_Rh_GetConversationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MessageList_Rh_GetConversationQuery, MessageList_Rh_GetConversationQueryVariables>(
    MessageList_Rh_GetConversationDocument,
    options,
  );
}
export function useMessageList_Rh_GetConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MessageList_Rh_GetConversationQuery,
    MessageList_Rh_GetConversationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MessageList_Rh_GetConversationQuery, MessageList_Rh_GetConversationQueryVariables>(
    MessageList_Rh_GetConversationDocument,
    options,
  );
}
export type MessageList_Rh_GetConversationQueryHookResult = ReturnType<typeof useMessageList_Rh_GetConversationQuery>;
export type MessageList_Rh_GetConversationLazyQueryHookResult = ReturnType<
  typeof useMessageList_Rh_GetConversationLazyQuery
>;
export function refetchMessageList_Rh_GetConversationQuery(variables?: MessageList_Rh_GetConversationQueryVariables) {
  return { query: MessageList_Rh_GetConversationDocument, variables: variables };
}
export const NoConversationsContent_GetLatestConversationsDocument = gql`
  query NoConversationsContent_GetLatestConversations($folder: Folder, $daysBack: Int) {
    RH_getLatestConversations(folder: $folder, daysBack: $daysBack) {
      conversations {
        conversationId
      }
    }
  }
`;

/**
 * __useNoConversationsContent_GetLatestConversationsQuery__
 *
 * To run a query within a React component, call `useNoConversationsContent_GetLatestConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoConversationsContent_GetLatestConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoConversationsContent_GetLatestConversationsQuery({
 *   variables: {
 *      folder: // value for 'folder'
 *      daysBack: // value for 'daysBack'
 *   },
 * });
 */
export function useNoConversationsContent_GetLatestConversationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NoConversationsContent_GetLatestConversationsQuery,
    NoConversationsContent_GetLatestConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NoConversationsContent_GetLatestConversationsQuery,
    NoConversationsContent_GetLatestConversationsQueryVariables
  >(NoConversationsContent_GetLatestConversationsDocument, options);
}
export function useNoConversationsContent_GetLatestConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NoConversationsContent_GetLatestConversationsQuery,
    NoConversationsContent_GetLatestConversationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NoConversationsContent_GetLatestConversationsQuery,
    NoConversationsContent_GetLatestConversationsQueryVariables
  >(NoConversationsContent_GetLatestConversationsDocument, options);
}
export type NoConversationsContent_GetLatestConversationsQueryHookResult = ReturnType<
  typeof useNoConversationsContent_GetLatestConversationsQuery
>;
export type NoConversationsContent_GetLatestConversationsLazyQueryHookResult = ReturnType<
  typeof useNoConversationsContent_GetLatestConversationsLazyQuery
>;
export function refetchNoConversationsContent_GetLatestConversationsQuery(
  variables?: NoConversationsContent_GetLatestConversationsQueryVariables,
) {
  return { query: NoConversationsContent_GetLatestConversationsDocument, variables: variables };
}
export const Rh_RequestToApplyDocument = gql`
  mutation RH_RequestToApply($alias: String, $email: String, $name: String, $requestToApply: Boolean, $text: String) {
    RH_RequestToApply(alias: $alias, email: $email, name: $name, requestToApply: $requestToApply, text: $text) {
      status
      success
    }
  }
`;
export type Rh_RequestToApplyMutationFn = Apollo.MutationFunction<
  Rh_RequestToApplyMutation,
  Rh_RequestToApplyMutationVariables
>;

/**
 * __useRh_RequestToApplyMutation__
 *
 * To run a mutation, you first call `useRh_RequestToApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRh_RequestToApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rhRequestToApplyMutation, { data, loading, error }] = useRh_RequestToApplyMutation({
 *   variables: {
 *      alias: // value for 'alias'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      requestToApply: // value for 'requestToApply'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useRh_RequestToApplyMutation(
  baseOptions?: Apollo.MutationHookOptions<Rh_RequestToApplyMutation, Rh_RequestToApplyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<Rh_RequestToApplyMutation, Rh_RequestToApplyMutationVariables>(
    Rh_RequestToApplyDocument,
    options,
  );
}
export type Rh_RequestToApplyMutationHookResult = ReturnType<typeof useRh_RequestToApplyMutation>;
export type Rh_RequestToApplyMutationOptions = Apollo.BaseMutationOptions<
  Rh_RequestToApplyMutation,
  Rh_RequestToApplyMutationVariables
>;
export const InboxPage_Rh_UpdateConversationStatusDocument = gql`
  mutation InboxPage_RH_UpdateConversationStatus(
    $conversationId: String!
    $isArchived: Boolean
    $reportReasonType: ReportConversationReason
  ) {
    RH_updateConversationStatusV2(
      conversationId: $conversationId
      isArchived: $isArchived
      reportReasonType: $reportReasonType
    ) {
      success
    }
  }
`;
export type InboxPage_Rh_UpdateConversationStatusMutationFn = Apollo.MutationFunction<
  InboxPage_Rh_UpdateConversationStatusMutation,
  InboxPage_Rh_UpdateConversationStatusMutationVariables
>;

/**
 * __useInboxPage_Rh_UpdateConversationStatusMutation__
 *
 * To run a mutation, you first call `useInboxPage_Rh_UpdateConversationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInboxPage_Rh_UpdateConversationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inboxPageRhUpdateConversationStatusMutation, { data, loading, error }] = useInboxPage_Rh_UpdateConversationStatusMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      isArchived: // value for 'isArchived'
 *      reportReasonType: // value for 'reportReasonType'
 *   },
 * });
 */
export function useInboxPage_Rh_UpdateConversationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InboxPage_Rh_UpdateConversationStatusMutation,
    InboxPage_Rh_UpdateConversationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InboxPage_Rh_UpdateConversationStatusMutation,
    InboxPage_Rh_UpdateConversationStatusMutationVariables
  >(InboxPage_Rh_UpdateConversationStatusDocument, options);
}
export type InboxPage_Rh_UpdateConversationStatusMutationHookResult = ReturnType<
  typeof useInboxPage_Rh_UpdateConversationStatusMutation
>;
export type InboxPage_Rh_UpdateConversationStatusMutationOptions = Apollo.BaseMutationOptions<
  InboxPage_Rh_UpdateConversationStatusMutation,
  InboxPage_Rh_UpdateConversationStatusMutationVariables
>;
export const Rh_GetSyndicationUrlsDocument = gql`
  query RH_getSyndicationUrls(
    $listingAlias: String!
    $fetchZillow: Boolean!
    $fetchHotpads: Boolean!
    $fetchTrulia: Boolean!
  ) {
    RH_getSyndicationUrls(listingAlias: $listingAlias) {
      hotpadsUrl @include(if: $fetchHotpads)
      zillowUrl @include(if: $fetchZillow)
      truliaUrl @include(if: $fetchTrulia)
    }
  }
`;

/**
 * __useRh_GetSyndicationUrlsQuery__
 *
 * To run a query within a React component, call `useRh_GetSyndicationUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRh_GetSyndicationUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRh_GetSyndicationUrlsQuery({
 *   variables: {
 *      listingAlias: // value for 'listingAlias'
 *      fetchZillow: // value for 'fetchZillow'
 *      fetchHotpads: // value for 'fetchHotpads'
 *      fetchTrulia: // value for 'fetchTrulia'
 *   },
 * });
 */
export function useRh_GetSyndicationUrlsQuery(
  baseOptions: Apollo.QueryHookOptions<Rh_GetSyndicationUrlsQuery, Rh_GetSyndicationUrlsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Rh_GetSyndicationUrlsQuery, Rh_GetSyndicationUrlsQueryVariables>(
    Rh_GetSyndicationUrlsDocument,
    options,
  );
}
export function useRh_GetSyndicationUrlsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Rh_GetSyndicationUrlsQuery, Rh_GetSyndicationUrlsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Rh_GetSyndicationUrlsQuery, Rh_GetSyndicationUrlsQueryVariables>(
    Rh_GetSyndicationUrlsDocument,
    options,
  );
}
export type Rh_GetSyndicationUrlsQueryHookResult = ReturnType<typeof useRh_GetSyndicationUrlsQuery>;
export type Rh_GetSyndicationUrlsLazyQueryHookResult = ReturnType<typeof useRh_GetSyndicationUrlsLazyQuery>;
export function refetchRh_GetSyndicationUrlsQuery(variables?: Rh_GetSyndicationUrlsQueryVariables) {
  return { query: Rh_GetSyndicationUrlsDocument, variables: variables };
}
export const InboxPage_Rh_FetchConversationIdDocument = gql`
  query InboxPage_RH_fetchConversationId($limit: Int, $folder: Folder) {
    RH_getLatestConversations(folder: $folder, limit: $limit) {
      conversations {
        conversationId
      }
    }
  }
`;

/**
 * __useInboxPage_Rh_FetchConversationIdQuery__
 *
 * To run a query within a React component, call `useInboxPage_Rh_FetchConversationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxPage_Rh_FetchConversationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxPage_Rh_FetchConversationIdQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useInboxPage_Rh_FetchConversationIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InboxPage_Rh_FetchConversationIdQuery,
    InboxPage_Rh_FetchConversationIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InboxPage_Rh_FetchConversationIdQuery, InboxPage_Rh_FetchConversationIdQueryVariables>(
    InboxPage_Rh_FetchConversationIdDocument,
    options,
  );
}
export function useInboxPage_Rh_FetchConversationIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxPage_Rh_FetchConversationIdQuery,
    InboxPage_Rh_FetchConversationIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InboxPage_Rh_FetchConversationIdQuery, InboxPage_Rh_FetchConversationIdQueryVariables>(
    InboxPage_Rh_FetchConversationIdDocument,
    options,
  );
}
export type InboxPage_Rh_FetchConversationIdQueryHookResult = ReturnType<
  typeof useInboxPage_Rh_FetchConversationIdQuery
>;
export type InboxPage_Rh_FetchConversationIdLazyQueryHookResult = ReturnType<
  typeof useInboxPage_Rh_FetchConversationIdLazyQuery
>;
export function refetchInboxPage_Rh_FetchConversationIdQuery(
  variables?: InboxPage_Rh_FetchConversationIdQueryVariables,
) {
  return { query: InboxPage_Rh_FetchConversationIdDocument, variables: variables };
}
export const InquiryPage_Rh_GetConversationForInquiryIdDocument = gql`
  query InquiryPage_RH_GetConversationForInquiryId($inquiryId: String!) {
    RH_getAllForInquiryId(inquiryId: $inquiryId, includeAttachmentsMetadata: true) {
      ...ConversationData
    }
  }
  ${ConversationDataFragmentDoc}
`;

/**
 * __useInquiryPage_Rh_GetConversationForInquiryIdQuery__
 *
 * To run a query within a React component, call `useInquiryPage_Rh_GetConversationForInquiryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInquiryPage_Rh_GetConversationForInquiryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInquiryPage_Rh_GetConversationForInquiryIdQuery({
 *   variables: {
 *      inquiryId: // value for 'inquiryId'
 *   },
 * });
 */
export function useInquiryPage_Rh_GetConversationForInquiryIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    InquiryPage_Rh_GetConversationForInquiryIdQuery,
    InquiryPage_Rh_GetConversationForInquiryIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InquiryPage_Rh_GetConversationForInquiryIdQuery,
    InquiryPage_Rh_GetConversationForInquiryIdQueryVariables
  >(InquiryPage_Rh_GetConversationForInquiryIdDocument, options);
}
export function useInquiryPage_Rh_GetConversationForInquiryIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InquiryPage_Rh_GetConversationForInquiryIdQuery,
    InquiryPage_Rh_GetConversationForInquiryIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InquiryPage_Rh_GetConversationForInquiryIdQuery,
    InquiryPage_Rh_GetConversationForInquiryIdQueryVariables
  >(InquiryPage_Rh_GetConversationForInquiryIdDocument, options);
}
export type InquiryPage_Rh_GetConversationForInquiryIdQueryHookResult = ReturnType<
  typeof useInquiryPage_Rh_GetConversationForInquiryIdQuery
>;
export type InquiryPage_Rh_GetConversationForInquiryIdLazyQueryHookResult = ReturnType<
  typeof useInquiryPage_Rh_GetConversationForInquiryIdLazyQuery
>;
export function refetchInquiryPage_Rh_GetConversationForInquiryIdQuery(
  variables?: InquiryPage_Rh_GetConversationForInquiryIdQueryVariables,
) {
  return { query: InquiryPage_Rh_GetConversationForInquiryIdDocument, variables: variables };
}
export const InboxRhPage_GetFeatureFlagsAndSettingsDocument = gql`
  query InboxRHPage_getFeatureFlagsAndSettings {
    getFeatureFlagsAndSettings(appName: "satellite_web") {
      features {
        enableExternalLinkWarningModal
        canAccessBlockedUserModalFromRJSModule
        enableWebsocketForRachelInbox
        enableInboxIA
        enableMessageLink
        enablePersonalInfoWarningModal
        enableRentingBuyingPills
        enableTMP
      }
      settings {
        aiConversationPollIntervalInSeconds
        abTreatmentForTMP
      }
    }
  }
`;

/**
 * __useInboxRhPage_GetFeatureFlagsAndSettingsQuery__
 *
 * To run a query within a React component, call `useInboxRhPage_GetFeatureFlagsAndSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxRhPage_GetFeatureFlagsAndSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxRhPage_GetFeatureFlagsAndSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxRhPage_GetFeatureFlagsAndSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InboxRhPage_GetFeatureFlagsAndSettingsQuery,
    InboxRhPage_GetFeatureFlagsAndSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InboxRhPage_GetFeatureFlagsAndSettingsQuery,
    InboxRhPage_GetFeatureFlagsAndSettingsQueryVariables
  >(InboxRhPage_GetFeatureFlagsAndSettingsDocument, options);
}
export function useInboxRhPage_GetFeatureFlagsAndSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxRhPage_GetFeatureFlagsAndSettingsQuery,
    InboxRhPage_GetFeatureFlagsAndSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InboxRhPage_GetFeatureFlagsAndSettingsQuery,
    InboxRhPage_GetFeatureFlagsAndSettingsQueryVariables
  >(InboxRhPage_GetFeatureFlagsAndSettingsDocument, options);
}
export type InboxRhPage_GetFeatureFlagsAndSettingsQueryHookResult = ReturnType<
  typeof useInboxRhPage_GetFeatureFlagsAndSettingsQuery
>;
export type InboxRhPage_GetFeatureFlagsAndSettingsLazyQueryHookResult = ReturnType<
  typeof useInboxRhPage_GetFeatureFlagsAndSettingsLazyQuery
>;
export function refetchInboxRhPage_GetFeatureFlagsAndSettingsQuery(
  variables?: InboxRhPage_GetFeatureFlagsAndSettingsQueryVariables,
) {
  return { query: InboxRhPage_GetFeatureFlagsAndSettingsDocument, variables: variables };
}
